/*! For license information please see aliplayercomponents-1.0.10.min.js.LICENSE.txt */
(() => {
  var A = {
      52: (A, t, e) => {
        'use strict';
        function i(A) {
          let t = document.createElement('div');
          return (t.innerHTML = A), t.childNodes[0];
        }
        function o(A, t, e) {
          var i = new Date();
          i.setTime(i.getTime() + 24 * e * 60 * 60 * 1e3);
          var o = 'expires=' + i.toGMTString();
          document.cookie = A + '=' + escape(t) + '; ' + o;
        }
        function n(A) {
          return A instanceof Element && A.nodeType === Node.ELEMENT_NODE;
        }
        e.d(t, { DR: () => o, a8: () => i, vq: () => n });
      },
      3446: function () {
        var A = (function () {
            var A = {
              bsearch: function (A, t, e) {
                if (0 === A.length) return 0;
                if (e(t, A[0]) < 0) return 0;
                if (e(t, A[A.length - 1]) >= 0) return A.length;
                for (var i = 0, o = 0, n = 0, l = A.length - 1; i <= l; ) {
                  if (
                    (n++,
                    e(t, A[(o = Math.floor((l + i + 1) / 2)) - 1]) >= 0 &&
                      e(t, A[o]) < 0)
                  )
                    return o;
                  e(t, A[o - 1]) < 0
                    ? (l = o - 1)
                    : e(t, A[o]) >= 0
                    ? (i = o)
                    : console.error('Program Error'),
                    n > 1500 && console.error('Too many run cycles.');
                }
                return -1;
              },
              binsert: function (t, e, i) {
                var o = A.bsearch(t, e, i);
                return t.splice(o, 0, e), o;
              },
            };
            return A;
          })(),
          t =
            (this && this.__extends) ||
            function (A, t) {
              for (var e in t) t.hasOwnProperty(e) && (A[e] = t[e]);
              function i() {
                this.constructor = A;
              }
              A.prototype =
                null === t
                  ? Object.create(t)
                  : ((i.prototype = t.prototype), new i());
            },
          e = (function () {
            function t(A, t) {
              void 0 === A && (A = 0),
                void 0 === t && (t = 0),
                (this._pools = [[]]),
                (this.avoid = 1),
                (this._width = A),
                (this._height = t);
            }
            return (
              (t.prototype.willCollide = function (A, t) {
                return A.stime + A.ttl >= t.stime + t.ttl / 2;
              }),
              (t.prototype.pathCheck = function (A, t, e) {
                for (
                  var i = A + t.height, o = t.right, n = 0;
                  n < e.length;
                  n++
                )
                  if (!(e[n].y > i || e[n].bottom < A)) {
                    if (!(e[n].right < t.x || e[n].x > o)) return !1;
                    if (this.willCollide(e[n], t)) return !1;
                  }
                return !0;
              }),
              (t.prototype.assign = function (A, t) {
                for (; this._pools.length <= t; ) this._pools.push([]);
                var e = this._pools[t];
                if (0 === e.length) return (A.cindex = t), 0;
                if (this.pathCheck(0, A, e)) return (A.cindex = t), 0;
                for (
                  var i = 0, o = 0;
                  o < e.length &&
                  !((i = e[o].bottom + this.avoid) + A.height > this._height);
                  o++
                )
                  if (this.pathCheck(i, A, e)) return (A.cindex = t), i;
                return this.assign(A, t + 1);
              }),
              (t.prototype.add = function (t) {
                t.height > this._height
                  ? ((t.cindex = -2), (t.y = 0))
                  : ((t.y = this.assign(t, 0)),
                    A.binsert(this._pools[t.cindex], t, function (A, t) {
                      return A.bottom < t.bottom
                        ? -1
                        : A.bottom > t.bottom
                        ? 1
                        : 0;
                    }));
              }),
              (t.prototype.remove = function (A) {
                if (!(A.cindex < 0)) {
                  if (A.cindex >= this._pools.length)
                    throw new Error('cindex out of bounds');
                  var t = this._pools[A.cindex].indexOf(A);
                  t < 0 || this._pools[A.cindex].splice(t, 1);
                }
              }),
              (t.prototype.setBounds = function (A, t) {
                (this._width = A), (this._height = t);
              }),
              t
            );
          })(),
          i = (function (A) {
            function e() {
              A.apply(this, arguments);
            }
            return (
              t(e, A),
              (e.prototype.add = function (t) {
                A.prototype.add.call(this, t),
                  (t.x = (this._width - t.width) / 2);
              }),
              (e.prototype.willCollide = function (A, t) {
                return !0;
              }),
              (e.prototype.pathCheck = function (A, t, e) {
                for (var i = A + t.height, o = 0; o < e.length; o++)
                  if (!(e[o].y > i || e[o].bottom < A)) return !1;
                return !0;
              }),
              e
            );
          })(e),
          o =
            ((t =
              (this && this.__extends) ||
              function (A, t) {
                for (var e in t) t.hasOwnProperty(e) && (A[e] = t[e]);
                function i() {
                  this.constructor = A;
                }
                A.prototype =
                  null === t
                    ? Object.create(t)
                    : ((i.prototype = t.prototype), new i());
              }),
            (function () {
              function A(t, e) {
                if (
                  (void 0 === e && (e = {}),
                  (this.mode = 1),
                  (this.stime = 0),
                  (this.text = ''),
                  (this.ttl = 4e3),
                  (this.dur = 4e3),
                  (this.cindex = -1),
                  (this.motion = []),
                  (this.movable = !0),
                  (this._alphaMotion = null),
                  (this.absolute = !0),
                  (this.align = 0),
                  (this._alpha = 1),
                  (this._size = 25),
                  (this._color = 16777215),
                  (this._border = !1),
                  (this._shadow = !0),
                  (this._font = ''),
                  !t)
                )
                  throw new Error('Comment not bound to comment manager.');
                if (
                  ((this.parent = t),
                  e.hasOwnProperty('stime') && (this.stime = e.stime),
                  e.hasOwnProperty('mode')
                    ? (this.mode = e.mode)
                    : (this.mode = 1),
                  e.hasOwnProperty('dur') &&
                    ((this.dur = e.dur), (this.ttl = this.dur)),
                  (this.dur *= this.parent.options.global.scale),
                  (this.ttl *= this.parent.options.global.scale),
                  e.hasOwnProperty('text') && (this.text = e.text),
                  e.hasOwnProperty('motion'))
                ) {
                  (this._motionStart = []),
                    (this._motionEnd = []),
                    (this.motion = e.motion);
                  for (var i = 0, o = 0; o < e.motion.length; o++) {
                    this._motionStart.push(i);
                    var n = 0;
                    for (var l in e.motion[o]) {
                      var s = e.motion[o][l];
                      (n = Math.max(s.dur, n)),
                        (null !== s.easing && void 0 !== s.easing) ||
                          (e.motion[o][l].easing = A.LINEAR);
                    }
                    (i += n), this._motionEnd.push(i);
                  }
                  this._curMotion = 0;
                }
                e.hasOwnProperty('color') && (this._color = e.color),
                  e.hasOwnProperty('size') && (this._size = e.size),
                  e.hasOwnProperty('border') && (this._border = e.border),
                  e.hasOwnProperty('opacity') && (this._alpha = e.opacity),
                  e.hasOwnProperty('alpha') && (this._alphaMotion = e.alpha),
                  e.hasOwnProperty('font') && (this._font = e.font),
                  e.hasOwnProperty('x') && (this._x = e.x),
                  e.hasOwnProperty('y') && (this._y = e.y),
                  e.hasOwnProperty('shadow') && (this._shadow = e.shadow),
                  e.hasOwnProperty('position') &&
                    'relative' === e.position &&
                    ((this.absolute = !1),
                    this.mode < 7 &&
                      console.warn('Using relative position for CSA comment.'));
              }
              return (
                (A.prototype.init = function (A) {
                  void 0 === A && (A = null),
                    (this.dom =
                      null !== A ? A.dom : document.createElement('div')),
                    (this.dom.className = this.parent.options.global.className),
                    this.dom.appendChild(document.createTextNode(this.text)),
                    (this.dom.textContent = this.text),
                    (this.dom.innerText = this.text),
                    (this.size = this._size),
                    16777215 != this._color && (this.color = this._color),
                    (this.shadow = this._shadow),
                    this._border && (this.border = this._border),
                    '' !== this._font && (this.font = this._font),
                    void 0 !== this._x && (this.x = this._x),
                    void 0 !== this._y && (this.y = this._y),
                    (1 !== this._alpha ||
                      this.parent.options.global.opacity < 1) &&
                      (this.alpha = this._alpha),
                    this.motion.length > 0 && this.animate();
                }),
                Object.defineProperty(A.prototype, 'x', {
                  get: function () {
                    return (
                      (null !== this._x && void 0 !== this._x) ||
                        (this.align % 2 == 0
                          ? (this._x = this.dom.offsetLeft)
                          : (this._x =
                              this.parent.width -
                              this.dom.offsetLeft -
                              this.width)),
                      this.absolute ? this._x : this._x / this.parent.width
                    );
                  },
                  set: function (A) {
                    (this._x = A),
                      this.absolute || (this._x *= this.parent.width),
                      this.align % 2 == 0
                        ? (this.dom.style.left = this._x + 'px')
                        : (this.dom.style.right = this._x + 'px');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'y', {
                  get: function () {
                    return (
                      (null !== this._y && void 0 !== this._y) ||
                        (this.align < 2
                          ? (this._y = this.dom.offsetTop)
                          : (this._y =
                              this.parent.height -
                              this.dom.offsetTop -
                              this.height)),
                      this.absolute ? this._y : this._y / this.parent.height
                    );
                  },
                  set: function (A) {
                    (this._y = A),
                      this.absolute || (this._y *= this.parent.height),
                      this.align < 2
                        ? (this.dom.style.top = this._y + 'px')
                        : (this.dom.style.bottom = this._y + 'px');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'bottom', {
                  get: function () {
                    return this.y + this.height;
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'right', {
                  get: function () {
                    return this.x + this.width;
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'width', {
                  get: function () {
                    return (
                      (null !== this._width && void 0 !== this._width) ||
                        (this._width = this.dom.offsetWidth),
                      this._width
                    );
                  },
                  set: function (A) {
                    (this._width = A),
                      (this.dom.style.width = this._width + 'px');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'height', {
                  get: function () {
                    return (
                      (null !== this._height && void 0 !== this._height) ||
                        (this._height = this.dom.offsetHeight),
                      this._height
                    );
                  },
                  set: function (A) {
                    (this._height = A),
                      (this.dom.style.height = this._height + 'px');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'size', {
                  get: function () {
                    return this._size;
                  },
                  set: function (A) {
                    (this._size = A),
                      (this.dom.style.fontSize = this._size + 'px');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'color', {
                  get: function () {
                    return this._color;
                  },
                  set: function (A) {
                    this._color = A;
                    var t = A.toString(16);
                    (t =
                      t.length >= 6
                        ? t
                        : new Array(6 - t.length + 1).join('0') + t),
                      (this.dom.style.color = '#' + t),
                      0 === this._color &&
                        (this.dom.className =
                          this.parent.options.global.className + ' rshadow');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'alpha', {
                  get: function () {
                    return this._alpha;
                  },
                  set: function (A) {
                    (this._alpha = A),
                      (this.dom.style.opacity =
                        Math.min(
                          this._alpha,
                          this.parent.options.global.opacity
                        ) + '');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'border', {
                  get: function () {
                    return this._border;
                  },
                  set: function (A) {
                    (this._border = A),
                      this._border
                        ? (this.dom.style.border = '1px solid #00ffff')
                        : (this.dom.style.border = 'none');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'shadow', {
                  get: function () {
                    return this._shadow;
                  },
                  set: function (A) {
                    (this._shadow = A),
                      this._shadow ||
                        (this.dom.className =
                          this.parent.options.global.className + ' noshadow');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                Object.defineProperty(A.prototype, 'font', {
                  get: function () {
                    return this._font;
                  },
                  set: function (A) {
                    (this._font = A),
                      this._font.length > 0
                        ? (this.dom.style.fontFamily = this._font)
                        : (this.dom.style.fontFamily = '');
                  },
                  enumerable: !0,
                  configurable: !0,
                }),
                (A.prototype.time = function (A) {
                  (this.ttl -= A),
                    this.ttl < 0 && (this.ttl = 0),
                    this.movable && this.update(),
                    this.ttl <= 0 && this.finish();
                }),
                (A.prototype.update = function () {
                  this.animate();
                }),
                (A.prototype.invalidate = function () {
                  (this._x = null),
                    (this._y = null),
                    (this._width = null),
                    (this._height = null);
                }),
                (A.prototype._execMotion = function (A, t) {
                  for (var e in A)
                    if (A.hasOwnProperty(e)) {
                      var i = A[e];
                      this[e] = i.easing(
                        Math.min(Math.max(t - i.delay, 0), i.dur),
                        i.from,
                        i.to - i.from,
                        i.dur
                      );
                    }
                }),
                (A.prototype.animate = function () {
                  if (
                    (this._alphaMotion &&
                      (this.alpha =
                        ((this.dur - this.ttl) *
                          (this._alphaMotion.to - this._alphaMotion.from)) /
                          this.dur +
                        this._alphaMotion.from),
                    0 !== this.motion.length)
                  ) {
                    var A = Math.max(this.ttl, 0),
                      t = this.dur - A - this._motionStart[this._curMotion];
                    return (
                      this._execMotion(this.motion[this._curMotion], t),
                      this.dur - A > this._motionEnd[this._curMotion]
                        ? (this._curMotion++,
                          void (
                            this._curMotion >= this.motion.length &&
                            (this._curMotion = this.motion.length - 1)
                          ))
                        : void 0
                    );
                  }
                }),
                (A.prototype.finish = function () {
                  this.parent.finish(this);
                }),
                (A.prototype.toString = function () {
                  return [
                    '[',
                    this.stime,
                    '|',
                    this.ttl,
                    '/',
                    this.dur,
                    ']',
                    '(',
                    this.mode,
                    ')',
                    this.text,
                  ].join('');
                }),
                (A.LINEAR = function (A, t, e, i) {
                  return (A * e) / i + t;
                }),
                A
              );
            })()),
          n = (function (A) {
            function e(t, e) {
              A.call(this, t, e),
                (this.dur *= this.parent.options.scroll.scale),
                (this.ttl *= this.parent.options.scroll.scale);
            }
            return (
              t(e, A),
              Object.defineProperty(e.prototype, 'alpha', {
                set: function (A) {
                  (this._alpha = A),
                    (this.dom.style.opacity =
                      Math.min(
                        Math.min(
                          this._alpha,
                          this.parent.options.global.opacity
                        ),
                        this.parent.options.scroll.opacity
                      ) + '');
                },
                enumerable: !0,
                configurable: !0,
              }),
              (e.prototype.init = function (t) {
                void 0 === t && (t = null),
                  A.prototype.init.call(this, t),
                  (this.x = this.parent.width),
                  this.parent.options.scroll.opacity < 1 &&
                    (this.alpha = this._alpha),
                  (this.absolute = !0);
              }),
              (e.prototype.update = function () {
                this.x =
                  (this.ttl / this.dur) * (this.parent.width + this.width) -
                  this.width;
              }),
              e
            );
          })(o);
        function l() {
          (this.modifiers = []),
            (this.runtime = null),
            (this.allowTypes = {
              1: !0,
              4: !0,
              5: !0,
              6: !0,
              7: !0,
              8: !0,
              17: !0,
            }),
            (this.doModify = function (A) {
              for (var t = 0; t < this.modifiers.length; t++)
                A = this.modifiers[t](A);
              return A;
            }),
            (this.beforeSend = function (A) {
              return A;
            }),
            (this.doValidate = function (A) {
              return !!this.allowTypes[A.mode];
            }),
            (this.addRule = function (A) {}),
            (this.addModifier = function (A) {
              this.modifiers.push(A);
            }),
            (this.runtimeFilter = function (A) {
              return null == this.runtime ? A : this.runtime(A);
            }),
            (this.setRuntimeFilter = function (A) {
              this.runtime = A;
            });
        }
        !(function () {
          var t = function (A, t) {
            for (
              var e = Math.PI / 180,
                i = A * e,
                o = t * e,
                n = Math.cos,
                l = Math.sin,
                s = [
                  n(i) * n(o),
                  n(i) * l(o),
                  l(i),
                  0,
                  -l(o),
                  n(o),
                  0,
                  0,
                  -l(i) * n(o),
                  -l(i) * l(o),
                  n(i),
                  0,
                  0,
                  0,
                  0,
                  1,
                ],
                a = 0;
              a < s.length;
              a++
            )
              Math.abs(s[a]) < 1e-6 && (s[a] = 0);
            return 'matrix3d(' + s.join(',') + ')';
          };
          function s(A) {
            var t = 0;
            (this._listeners = {}),
              (this._lastPosition = 0),
              (this.stage = A),
              (this.options = {
                global: { opacity: 1, scale: 1, className: 'cmt' },
                scroll: { opacity: 1, scale: 1 },
                limit: 0,
              }),
              (this.timeline = []),
              (this.runline = []),
              (this.position = 0),
              (this.limiter = 0),
              (this.filter = null),
              (this.csa = {
                scroll: new e(0, 0),
                top: new i(0, 0),
                bottom: new i(0, 0),
                reverse: new e(0, 0),
                scrollbtm: new e(0, 0),
              }),
              (this.width = this.stage.offsetWidth),
              (this.height = this.stage.offsetHeight),
              (this.startTimer = function () {
                if (!(t > 0)) {
                  var A = new Date().getTime(),
                    e = this;
                  t = window.setInterval(function () {
                    var t = new Date().getTime() - A;
                    (A = new Date().getTime()), e.onTimerEvent(t, e);
                  }, 10);
                }
              }),
              (this.stopTimer = function () {
                window.clearInterval(t), (t = 0);
              });
          }
          (s.prototype.stop = function () {
            this.stopTimer();
          }),
            (s.prototype.start = function () {
              this.startTimer();
            }),
            (s.prototype.seek = function (t) {
              this.position = A.bsearch(this.timeline, t, function (A, t) {
                return A < t.stime ? -1 : A > t.stime ? 1 : 0;
              });
            }),
            (s.prototype.validate = function (A) {
              return null != A && this.filter.doValidate(A);
            }),
            (s.prototype.load = function (A) {
              (this.timeline = A),
                this.timeline.sort(function (A, t) {
                  return A.stime > t.stime
                    ? 2
                    : A.stime < t.stime
                    ? -2
                    : A.date > t.date
                    ? 1
                    : A.date < t.date
                    ? -1
                    : null != A.dbid && null != t.dbid
                    ? A.dbid > t.dbid
                      ? 1
                      : A.dbid < t.dbid
                      ? -1
                      : 0
                    : 0;
                }),
                this.dispatchEvent('load');
            }),
            (s.prototype.insert = function (t) {
              A.binsert(this.timeline, t, function (A, t) {
                return A.stime > t.stime
                  ? 2
                  : A.stime < t.stime
                  ? -2
                  : A.date > t.date
                  ? 1
                  : A.date < t.date
                  ? -1
                  : null != A.dbid && null != t.dbid
                  ? A.dbid > t.dbid
                    ? 1
                    : A.dbid < t.dbid
                    ? -1
                    : 0
                  : 0;
              }) <= this.position && this.position++,
                this.dispatchEvent('insert');
            }),
            (s.prototype.clear = function () {
              for (; this.runline.length > 0; ) this.runline[0].finish();
              this.dispatchEvent('clear');
            }),
            (s.prototype.setBounds = function () {
              for (var A in ((this.width = this.stage.offsetWidth),
              (this.height = this.stage.offsetHeight),
              this.dispatchEvent('resize'),
              this.csa))
                this.csa[A].setBounds(this.width, this.height);
              (this.stage.style.perspective =
                (this.width * Math.tan((40 * Math.PI) / 180)) / 2 + 'px'),
                (this.stage.style.webkitPerspective =
                  (this.width * Math.tan((40 * Math.PI) / 180)) / 2 + 'px');
            }),
            (s.prototype.init = function () {
              this.setBounds(), null == this.filter && (this.filter = new l());
            }),
            (s.prototype.time = function (A) {
              if (
                ((A -= 1),
                this.position >= this.timeline.length ||
                  Math.abs(this._lastPosition - A) >= 2e3)
              ) {
                if (
                  (this.seek(A),
                  (this._lastPosition = A),
                  this.timeline.length <= this.position)
                )
                  return;
              } else this._lastPosition = A;
              for (
                ;
                this.position < this.timeline.length &&
                this.timeline[this.position].stime <= A;
                this.position++
              )
                (this.options.limit > 0 &&
                  this.runline.length > this.limiter) ||
                  (this.validate(this.timeline[this.position]) &&
                    this.send(this.timeline[this.position]));
            }),
            (s.prototype.rescale = function () {}),
            (s.prototype.send = function (A) {
              if (8 === A.mode)
                return (
                  console.log(A),
                  void (
                    this.scripting && console.log(this.scripting.eval(A.code))
                  )
                );
              if (
                null == this.filter ||
                null != (A = this.filter.doModify(A))
              ) {
                if (1 === A.mode || 2 === A.mode || 6 === A.mode)
                  var e = new n(this, A);
                else e = new o(this, A);
                switch (e.mode) {
                  case 1:
                  case 5:
                    e.align = 0;
                    break;
                  case 2:
                  case 4:
                    e.align = 2;
                    break;
                  case 6:
                    e.align = 1;
                }
                switch ((e.init(), this.stage.appendChild(e.dom), e.mode)) {
                  default:
                  case 1:
                    this.csa.scroll.add(e);
                    break;
                  case 2:
                    this.csa.scrollbtm.add(e);
                    break;
                  case 4:
                    this.csa.bottom.add(e);
                    break;
                  case 5:
                    this.csa.top.add(e);
                    break;
                  case 6:
                    this.csa.reverse.add(e);
                    break;
                  case 17:
                  case 7:
                    (0 === A.rY && 0 === A.rZ) ||
                      ((e.dom.style.transform = t(A.rY, A.rZ)),
                      (e.dom.style.webkitTransform = t(A.rY, A.rZ)),
                      (e.dom.style.OTransform = t(A.rY, A.rZ)),
                      (e.dom.style.MozTransform = t(A.rY, A.rZ)),
                      (e.dom.style.MSTransform = t(A.rY, A.rZ)));
                }
                (e.y = e.y),
                  this.dispatchEvent('enterComment', e),
                  this.runline.push(e);
              }
            }),
            (s.prototype.sendComment = function (A) {
              console.log(
                'CommentManager.sendComment is deprecated. Please use send instead'
              ),
                this.send(A);
            }),
            (s.prototype.finish = function (A) {
              this.dispatchEvent('exitComment', A),
                this.stage.removeChild(A.dom);
              var t = this.runline.indexOf(A);
              switch ((t >= 0 && this.runline.splice(t, 1), A.mode)) {
                default:
                case 1:
                  this.csa.scroll.remove(A);
                  break;
                case 2:
                  this.csa.scrollbtm.remove(A);
                  break;
                case 4:
                  this.csa.bottom.remove(A);
                  break;
                case 5:
                  this.csa.top.remove(A);
                  break;
                case 6:
                  this.csa.reverse.remove(A);
                case 7:
              }
            }),
            (s.prototype.addEventListener = function (A, t) {
              void 0 !== this._listeners[A]
                ? this._listeners[A].push(t)
                : (this._listeners[A] = [t]);
            }),
            (s.prototype.dispatchEvent = function (A, t) {
              if (void 0 !== this._listeners[A])
                for (var e = 0; e < this._listeners[A].length; e++)
                  try {
                    this._listeners[A][e](t);
                  } catch (A) {
                    console.err(A.stack);
                  }
            }),
            (s.prototype.onTimerEvent = function (A, t) {
              for (var e = 0; e < t.runline.length; e++) {
                var i = t.runline[e];
                i.hold || i.time(A);
              }
            });
        })();
      },
      3525: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.abp{position:relative}.abp .container{-webkit-transform:matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);transform:matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);position:absolute;display:block;overflow:hidden;margin:0;border:0;top:0;left:0;bottom:0;right:0;z-index:9999;touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.abp .container .cmt{-webkit-transform:matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);transform:matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);-webkit-transform-origin:0% 0%;-ms-transform-origin:0% 0%;transform-origin:0% 0%;position:absolute;padding:3px 0 0 0;margin:0;color:#fff;font-family:SimHei, SimSun, Heiti, "MS Mincho", "Meiryo", "Microsoft YaHei", monospace;font-size:25px;text-decoration:none;text-shadow:-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;text-size-adjust:none;line-height:100%;letter-spacing:0;word-break:keep-all;white-space:pre}.abp .container .cmt.noshadow{text-shadow:none}.abp .container .cmt.rshadow{text-shadow:-1px 0 white, 0 1px white, 1px 0 white, 0 -1px white}@font-face{font-family:"\\9ED1\\4F53";src:local("SimHei")}@font-face{font-family:"\\5B8B\\4F53";src:local("SimSun")}@font-face{font-family:"\\534E\\6587\\6977\\4F53";src:local("SimKai")}@font-face{font-family:"\\5E7C\\5706";src:local("YouYuan")}@font-face{font-family:"\\5FAE\\8F6F\\96C5\\9ED1";src:local("Microsoft YaHei")}\n',
          '',
        ]);
        const s = l;
      },
      807: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => w });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n),
          s = e(4417),
          a = e.n(s),
          r = new URL(e(5029), e.b),
          d = new URL(e(396), e.b),
          c = new URL(e(4427), e.b),
          h = new URL(e(7214), e.b),
          p = l()(o()),
          u = a()(r),
          m = a()(r, { hash: '#iefix' }),
          y = a()(d),
          g = a()(c),
          M = a()(h, { hash: '#iconfont' });
        p.push([
          A.id,
          `@font-face{font-family:"iconfont";src:url(${u});src:url(${m}) format("embedded-opentype"),url(${y}) format("woff"),url(${g}) format("truetype"),url(${M}) format("svg")}.iconfont{font-family:"iconfont" !important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-list:before{content:"\\e643"}.icon-skipnext:before{content:"\\ea9e"}.icon-skip-previous:before{content:"\\e6d3"}.icon-close:before{content:"\\e616"}.icon-player-rotate-left:before{content:"\\e658"}.icon-player-rotate-right:before{content:"\\e659"}.icon-player-switch:before{content:"\\e781"}.icon-danmu-close:before{content:"\\e696"}.icon-danmu-open:before{content:"\\e697"}.icon-player-play:before{content:"\\e641"}body{font-family:"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif}.vip-join{color:#00c1de}.vip_limit_content{display:flex;width:100%;height:100%;flex-wrap:wrap;justify-content:center;align-items:center}.vip_limit_content .title{font-size:18px;line-height:36px;color:#fff;text-align:center;width:100%}.vip_limit_button_box{text-align:center;white-space:nowrap;overflow:hidden;width:100%}.vip_limit_btn{display:inline-block;min-width:100px;position:relative;background:#f60;padding:0 35px;margin:0px 5px 20px 5px;border-radius:38px;font-size:18px;line-height:38px;color:#623A0C;text-align:center;background-image:linear-gradient(-135deg, #FBE8A8 0%, #F8E7AC 15%, #E2C078 100%);cursor:pointer}.vip_limit_close{text-align:center}.vip_limit_close span{display:inline-block;width:40px;height:40px;line-height:36px;background:rgba(165,165,165,0.54);border-radius:50%;font-size:24px;cursor:pointer}\n`,
          '',
        ]);
        const w = p;
      },
      631: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.aliplayer-danmuku{position:absolute;top:0;left:0;width:100%;height:100%}.aliplayer-danmuku.abp{position:absolute}.aliplayer-danmuku.abp .container{z-index:0}.aliplayer-danmuku .danmu{position:absolute;width:100%;height:100%}.ali-danmuku-control{float:right;color:#fff;margin-right:5px;position:relative;display:table-cell;margin-top:8px}.ali-danmuku-control .iconfont{font-size:35px;cursor:pointer;vertical-align:middle;user-select:none;line-height:initial}.ali-danmuku-control .iconfont.icon-danmu-close{display:inline-block}.ali-danmuku-control .player-tooltip.close,.ali-danmuku-control .player-tooltip.open{right:-12px}@media (min-width: 768px){.ali-danmuku-control .icon-danmu-close:hover+.player-tooltip{display:block}.ali-danmuku-control .icon-danmu-open:hover+.player-tooltip{display:block}}.ali-danmuku-control .ali-danmu-input-wrap{width:200px;display:none}.ali-danmu-input{position:relative;width:100%;display:inline-block}.ali-danmu-input input{display:inline-block;width:100%;padding-right:40px;box-sizing:border-box;padding:5px 40px 5px 5px;background-color:rgba(130,132,138,0.4);border:1px solid #c0c4cc;font-size:14px;color:#fff;border-radius:3px}.ali-danmu-input input:focus{outline:none;border-color:#0f84fd}.ali-danmu-input .danmu-input-enter{position:absolute;right:0;top:0;border:1px solid;color:#fff;background-color:#0f84fd;border-color:#0f84fd;font-size:12px;padding:6px 7px;display:inline-block;height:28px;border-radius:0 3px 3px 0;cursor:pointer}.ali-danmu-input .danmu-input-enter:focus{outline:none}.ali-danmu-input .danmu-input-enter:hover{background-color:#288df5;border-color:#288df5}\n',
          '',
        ]);
        const s = l;
      },
      2049: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.bullet-screen{position:absolute;white-space:nowrap;animation:bullet 10s linear infinite}@keyframes bullet{from{left:100%}to{left:0%;transform:translateX(-100%)}}\n',
          '',
        ]);
        const s = l;
      },
      1209: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.player-hidden{display:none !important}.caption-components{float:right;color:#fff;height:35px;position:relative;box-sizing:border-box;margin-top:5px}.current-caption{display:flex;height:100%;align-items:center;justify-content:center;width:100px;cursor:pointer}.caption-list{position:absolute;bottom:46px;display:none;padding:0;margin:0;list-style:none;height:150px;width:100px;overflow-y:scroll}.caption-list li{text-align:center;width:100px;line-height:30px;background-color:rgba(0,0,0,0.6);cursor:pointer}.caption-list li.current{color:#00c1de}.caption-list li+li{border-top:1px solid rgba(78,78,78,0.3)}.caption-list li:hover{background-color:rgba(0,0,0,0.5)}@media (max-width: 768px){.current-caption{width:40px}.caption-list li{width:43px}}.prism-player .prism-info-display .switchimg{color:#fff}\n',
          '',
        ]);
        const s = l;
      },
      6730: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          ".many-video-ad-component{width:100%;height:100%;position:absolute;top:0;left:0;z-index:2147483647;background-color:#000;font-size:12px}.many-video-ad-component #many-video-ad-content{width:100%;height:100%}.many-video-ad-component .many-video-ad-link{width:100%;height:100%;display:block;position:absolute;top:0;left:0}.many-video-ad-component .many-video-ad-close{background-color:rgba(59,59,59,0.85);position:absolute;top:15px;right:20px;color:#fff;line-height:26px;padding:0 10px;user-select:none}.many-video-ad-component .many-video-ad-close #many-video-ad-duration{color:#00c1de;vertical-align:top;font-size:14px;position:relative;display:inline-block;text-align:right}.many-video-ad-component .many-video-ad-close #many-video-ad-duration::after{background-color:#fff;position:absolute;content:'';right:-7px;top:8px;bottom:8px;width:1px}.many-video-ad-component .many-video-ad-close label{cursor:pointer;display:inline-block}.many-video-ad-component .many-video-ad-close .icon-close{font-size:12px;vertical-align:top}@media (min-width: 768px){.many-video-ad-component .many-video-ad-close .icon-close:hover{color:#00c1de}}.many-video-ad-component .many-video-ad-close .many-video-ad-close-text{padding:0 5px 0 10px}.many-video-ad-component .many-video-ad-detail{position:absolute;right:35px;bottom:30px;background-color:rgba(0,222,255,0.85);color:#fff;padding:8px 12px;user-select:none;cursor:pointer;transition:background-color .15s}@media (min-width: 768px){.many-video-ad-component .many-video-ad-detail:hover{background-color:#00deff}}.many-video-ad-component .autoplay-many-video-ad{position:absolute;color:#fff;top:50%;left:50%;text-align:center;padding:10px;border-radius:5px;background-color:rgba(144,147,153,0.85);transform:translate(-50%, -50%);display:none}.many-video-ad-component .autoplay-many-video-ad i{font-size:42px;margin-bottom:7px;display:inline-block;cursor:pointer}.many-video-ad-component .autoplay-many-video-ad i+span{margin-bottom:5px}.many-video-ad-component .autoplay-many-video-ad span{display:block}.controlbar-element-hidden{display:none !important}\n",
          '',
        ]);
        const s = l;
      },
      4078: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.memory-play-wrap{position:absolute;right:10px;bottom:55px}.memory-play-wrap .memory-play{padding:13px 20px;background-color:#191919;background-color:rgba(25,25,25,0.88);border-radius:4px;color:#fff;font-size:14px;user-select:none}.memory-play-wrap .memory-play .icon-close{transition:color .3s;font-size:14px;cursor:pointer}@media (min-width: 768px){.memory-play-wrap .memory-play .icon-close:hover{color:#00c1de}}.memory-play-wrap .memory-play .play-jump{color:#00c1de;padding:5px;border-radius:3px;cursor:pointer}@media (min-width: 768px){.memory-play-wrap .memory-play .play-jump:hover{background-color:rgba(255,255,255,0.2)}}\n',
          '',
        ]);
        const s = l;
      },
      2190: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.pause-ad{width:60%;height:50%;background:#000;top:50%;left:50%;transform:translate(-50%, -50%);position:absolute;display:none}.pause-ad .btn-close{position:absolute;top:5px;right:5px;background-color:#333;width:2px;height:15px;padding:2px 8px;cursor:pointer}.pause-ad .btn-close i{background-color:#fff;width:2px;height:15px;position:absolute}.pause-ad .btn-close .split-left{transform:rotate(-45deg)}.pause-ad .btn-close .split-right{transform:rotate(45deg)}.pause-ad .ad-text{position:absolute;left:5px;top:5px;background-color:#333;color:#fff;padding:3px 5px;font-size:14px}.pause-ad .ad-content{width:100%;height:100%;display:flex;align-items:center;justify-content:center}.pause-ad .ad-content img{max-width:100%;max-height:100%}\n',
          '',
        ]);
        const s = l;
      },
      4843: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.playlist-component{color:#fff;float:left;height:35px;margin-top:5px;display:flex;align-items:center;position:relative}.playlist-component i{color:#fff;display:inline-block;font-size:22px;display:block;margin-top:7px;cursor:pointer}.playlist-component i+i{margin-left:3px}@media (min-width: 768px){.playlist-component i:hover+.player-tooltip{display:block}}.playlist-component .player-tooltip.prev{left:-10px}.playlist-component .player-tooltip.list{left:5px}.playlist-component .player-tooltip.next{right:-12px}.playlist-content{position:absolute;right:0;width:0px;padding-bottom:48px;box-sizing:border-box;height:100%;transition:all .38s ease-in-out;overflow:hidden}.playlist-content .list{background-color:#000;background-color:rgba(0,0,0,0.3);height:100%;overflow:auto}.playlist-content .list .video-item{color:#fff;padding:0px 10px;line-height:35px;font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;cursor:pointer}.playlist-content .list .video-item.active{background-color:#000;color:#00ddff}@media (min-width: 768px){.playlist-content .list .video-item:hover{background-color:#000;color:#00ddff}}.player-tooltip{position:absolute;display:none;font-size:12px;color:#fff;line-height:28px;letter-spacing:0;text-align:center;background:#3c3c3c;box-shadow:0 0 5px 0 rgba(0,0,0,0.1);height:28px;top:-48px;padding:0 5px;white-space:nowrap}.playlist-skip-tip{padding:5px 15px;position:absolute;top:50%;left:50%;z-index:30;line-height:30px;font-size:14px;border-radius:4px;background:rgba(255,255,255,0.8);color:#000;text-align:center;transform:translate(-50%, -50%)}\n',
          '',
        ]);
        const s = l;
      },
      9918: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.preview-hide{display:none !important}.preview-vod-component{display:none}.preview-vod-component .preview-component-layer{position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,0.8);z-index:9998;box-sizing:border-box;padding:20px 20px 70px;display:none}.preview-vod-component .preview-component-layer .preview-close{position:absolute;right:18px;top:15px;border-radius:50%;color:#000;background:#fff;width:20px;height:20px;text-align:center;line-height:18px;vertical-align:top;color:#333;box-shadow:0 0 5px rgba(0,0,0,0.3);cursor:pointer;z-index:9998}.preview-vod-component .preview-component-layer .preview-custom{width:100%;height:100%;position:relative}.preview-vod-component .preview-component-layer .preview-custom .preview-default{font-size:14px;color:#fff;text-align:center;position:absolute;top:50%;transform:translateY(-50%);width:100%}.preview-vod-component .preview-custom{color:#fff;font-size:14px}.preview-vod-component .preview-component-tip{position:absolute;bottom:50px;left:25px;border-radius:15px;background-color:#333;color:#fff;line-height:26px;font-size:14px;padding:0 12px;z-index:9998}.preview-vod-component .preview-vod-close{font-size:18px;cursor:pointer;padding:0 5px;font-family:PingFangSC-Regular, sans-serif;font-weight:200}.preview-vod-component .preview-vod-close:hover{color:#00c1de}\n',
          '',
        ]);
        const s = l;
      },
      2008: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => N });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n),
          s = e(4417),
          a = e.n(s),
          r = new URL(e(1961), e.b),
          d = new URL(e(9099), e.b),
          c = new URL(e(3655), e.b),
          h = new URL(e(6999), e.b),
          p = new URL(e(2322), e.b),
          u = l()(o()),
          m = a()(r),
          y = a()(r, { hash: '#iefix' }),
          g = a()(d),
          M = a()(c),
          w = a()(h),
          v = a()(p, { hash: '#iconfont' });
        u.push([
          A.id,
          `@font-face{font-family:"iconfont";src:url(${m});src:url(${y}) format("embedded-opentype"),url(${g}) format("woff2"),url(${M}) format("woff"),url(${w}) format("truetype"),url(${v}) format("svg")}.iconfont{font-family:"iconfont" !important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-play:before{content:"\\e726"}.icon-arrowdown:before{content:"\\e623"}.clearfix:before,.clearfix:after{content:"";display:table;line-height:0}.clearfix:after{clear:both}.clearfix{*zoom:1}.progress-component{padding:8px;background-color:rgba(0,0,0,0.35);position:absolute;display:none;box-sizing:border-box;bottom:55px;font-size:12px;color:#fff;height:74px;z-index:10}.progress-component .progress-content{height:100%;position:relative;padding-right:45px}.progress-component .img-wrap{float:left;width:100px;text-align:center;border:1px solid rgba(0,0,0,0.6);height:100%}.progress-component .img-wrap img{vertical-align:top;max-width:100%;max-height:100%;object-fit:contain}.progress-component .info{float:left;padding-left:10px;width:150px}.progress-component .info .describe{line-height:18px;margin-top:8px;height:36px;overflow:hidden}.progress-component .pregress-play-btn{display:inline-block;position:absolute;right:6px;bottom:0px;font-size:28px;color:#ca7838;cursor:pointer}.progress-component .icon-arrowdown{left:-2px;position:absolute;font-size:31px;color:rgba(0,0,0,0.35);line-height:6px;top:100%}\n`,
          '',
        ]);
        const N = u;
      },
      4200: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.player-hidden{display:none !important}.quality-components{float:right;color:#fff;height:35px;position:relative;box-sizing:border-box;margin-top:4px}.current-quality{display:flex;height:100%;align-items:center;justify-content:center;width:70px;cursor:pointer}.quality-list{position:absolute;bottom:46px;display:none;padding:0;margin:0;list-style:none}.quality-list li{text-align:center;width:70px;line-height:30px;background-color:rgba(0,0,0,0.6);cursor:pointer}.quality-list li.current{color:#00c1de}.quality-list li+li{border-top:1px solid rgba(78,78,78,0.3)}.quality-list li:hover{background-color:rgba(0,0,0,0.5)}.quality-modal{position:absolute;bottom:20%;left:5%;background-color:rgba(0,0,0,0.6);border-radius:5px;color:#fff;padding:10px 15px;font-size:14px;display:none}.quality-modal span.current-quality-tag{color:#00c1de}@media (max-width: 768px){.current-quality{width:40px}.quality-list li{width:45px}}\n',
          '',
        ]);
        const s = l;
      },
      6175: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.player-hidden{display:none !important}.rate-components{float:right;color:#fff;height:35px;position:relative;box-sizing:border-box;margin-top:5px}.current-rate{display:flex;height:100%;align-items:center;justify-content:center;width:70px;cursor:pointer}.rate-list{position:absolute;bottom:46px;display:none;padding:0;margin:0;list-style:none}.rate-list li{text-align:center;width:70px;line-height:30px;background-color:rgba(0,0,0,0.6);cursor:pointer}.rate-list li.current{color:#00c1de}.rate-list li+li{border-top:1px solid rgba(78,78,78,0.3)}.rate-list li:hover{background-color:rgba(0,0,0,0.5)}@media (max-width: 768px){.current-rate{width:40px}.rate-list li{width:43px}}\n',
          '',
        ]);
        const s = l;
      },
      6481: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.aliplayer-rotate-mirror{float:right;color:#fff;display:flex;align-items:center;height:35px;position:relative;margin-top:5px}.aliplayer-rotate-mirror i{color:#fff;display:inline-block;font-size:22px;display:block;margin-top:7px;cursor:pointer;margin-right:10px}.aliplayer-rotate-mirror i.icon-player-switch{font-size:24px;font-weight:bold}@media (min-width: 768px){.aliplayer-rotate-mirror i:hover+.player-tooltip{display:block}}.aliplayer-rotate-mirror .mirror-option{position:absolute;background-color:#3c3c3c;top:0;transform:translateY(-103%);right:-20px}.aliplayer-rotate-mirror .mirror-option .mirror-item{font-size:14px;color:#ebecec;line-height:30px;white-space:nowrap;padding:0 15px;cursor:pointer;user-select:none}.aliplayer-rotate-mirror .mirror-option .mirror-item[data-id="counterclockwise"]{display:none}.aliplayer-rotate-mirror .mirror-option .mirror-item[data-id="clockwise"]{display:none}.aliplayer-rotate-mirror .mirror-option .mirror-item.active{background-color:rgba(216,216,216,0.1);color:#00c1de}.aliplayer-rotate-mirror .player-tooltip.counterclockwise{left:-35px}.aliplayer-rotate-mirror .player-tooltip.clockwise{left:-5px}.aliplayer-rotate-mirror .player-tooltip.switch{right:7px}@media (max-width: 768px){.aliplayer-rotate-mirror .mirror-option .mirror-item[data-id="counterclockwise"]{display:block}.aliplayer-rotate-mirror .mirror-option .mirror-item[data-id="clockwise"]{display:block}}\n',
          '',
        ]);
        const s = l;
      },
      2484: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.start-ad{width:100%;height:100%;box-sizing:border-box;background-color:#000;position:absolute;z-index:9999}.start-ad .tip{position:absolute;right:5px;top:5px;background-color:#333;color:#fff;font-size:14px;text-align:center;padding:3px 7px}.start-ad .tip i{font-style:normal}.start-ad a{width:100%;height:100%;display:inline-block;text-align:center;display:flex;align-items:center;justify-content:center}.start-ad a img{max-width:100%;max-height:100%}\n',
          '',
        ]);
        const s = l;
      },
      9218: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.player-hidden{display:none !important}.track-components{float:right;color:#fff;height:35px;position:relative;box-sizing:border-box;margin-top:5px}.current-track{display:flex;height:100%;align-items:center;justify-content:center;width:100px;cursor:pointer}.track-list{position:absolute;bottom:46px;display:none;padding:0;margin:0;list-style:none;height:auto;width:100px;overflow-y:scroll}.track-list li{text-align:center;width:100px;line-height:30px;background-color:rgba(0,0,0,0.6);cursor:pointer}.track-list li.current{color:#00c1de}.track-list li+li{border-top:1px solid rgba(78,78,78,0.3)}.track-list li:hover{background-color:rgba(0,0,0,0.5)}@media (max-width: 768px){.current-track{width:40px}.track-list li{width:43px}}.prism-player .prism-info-display .switchimg{color:#fff}\n',
          '',
        ]);
        const s = l;
      },
      6613: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          ".video-ad-component{width:100%;height:100%;position:absolute;top:0;left:0;z-index:2147483647;background-color:#000;font-size:12px}.video-ad-component #video-ad-content{width:100%;height:100%}.video-ad-component .video-ad-link{width:100%;height:100%;display:block;position:absolute;top:0;left:0}.video-ad-component .video-ad-close{background-color:rgba(59,59,59,0.85);position:absolute;top:15px;right:20px;color:#fff;line-height:26px;padding:0 10px;user-select:none}.video-ad-component .video-ad-close #video-ad-duration{color:#00c1de;vertical-align:top;font-size:14px;position:relative;display:inline-block;text-align:right}.video-ad-component .video-ad-close #video-ad-duration::after{background-color:#fff;position:absolute;content:'';right:-7px;top:8px;bottom:8px;width:1px}.video-ad-component .video-ad-close label{cursor:pointer;display:inline-block}.video-ad-component .video-ad-close .icon-close{font-size:12px;vertical-align:top}@media (min-width: 768px){.video-ad-component .video-ad-close .icon-close:hover{color:#00c1de}}.video-ad-component .video-ad-close .video-ad-close-text{padding:0 5px 0 10px}.video-ad-component .video-ad-detail{position:absolute;right:35px;bottom:30px;background-color:rgba(0,222,255,0.85);color:#fff;padding:8px 12px;user-select:none;cursor:pointer;transition:background-color .15s}@media (min-width: 768px){.video-ad-component .video-ad-detail:hover{background-color:#00deff}}.video-ad-component .autoplay-video-ad{position:absolute;color:#fff;top:50%;left:50%;text-align:center;padding:10px;border-radius:5px;background-color:rgba(144,147,153,0.85);transform:translate(-50%, -50%);display:none}.video-ad-component .autoplay-video-ad i{font-size:42px;margin-bottom:7px;display:inline-block;cursor:pointer}.video-ad-component .autoplay-video-ad i+span{margin-bottom:5px}.video-ad-component .autoplay-video-ad span{display:block}.controlbar-element-hidden{display:none !important}\n",
          '',
        ]);
        const s = l;
      },
      5570: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => h });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n),
          s = e(4417),
          a = e.n(s),
          r = new URL(e(9379), e.b),
          d = l()(o()),
          c = a()(r);
        d.push([
          A.id,
          `.player-olympic-player-next{width:32px;height:32px;background:url(${c}) center no-repeat;background-size:contain;float:left;margin-left:10px;margin-top:8px;cursor:pointer;position:relative}.player-olympic-player-next-tip{position:absolute;top:-45px;display:none;font-size:12px;color:#ffffff;line-height:28px;letter-spacing:0;text-align:center;background:#3c3c3c;box-shadow:0 0 5px 0 rgba(0,0,0,0.1);width:58px;height:28px}.player-olympic-player-next:hover .player-olympic-player-next-tip{display:block}\n`,
          '',
        ]);
        const h = d;
      },
      1305: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => s });
        var i = e(1601),
          o = e.n(i),
          n = e(6314),
          l = e.n(n)()(o());
        l.push([
          A.id,
          '.ad-container{display:none;position:absolute;left:50%;top:50%;margin-left:-150px;margin-top:-100px}.ad-container span{width:27px;height:16px;border-radius:1px;background-color:rgba(0,0,0,0.5);position:absolute;font-size:10px;color:#fff;line-height:16px;text-align:center;top:0px;left:0px}.ad-container .close{position:absolute;top:2px;right:2px;width:20px;height:20px}.ad-container .close:hover{cursor:pointer}.ad-container .ad{width:300px;height:200px}\n',
          '',
        ]);
        const s = l;
      },
      6314: (A) => {
        'use strict';
        A.exports = function (A) {
          var t = [];
          return (
            (t.toString = function () {
              return this.map(function (t) {
                var e = '',
                  i = void 0 !== t[5];
                return (
                  t[4] && (e += '@supports ('.concat(t[4], ') {')),
                  t[2] && (e += '@media '.concat(t[2], ' {')),
                  i &&
                    (e += '@layer'.concat(
                      t[5].length > 0 ? ' '.concat(t[5]) : '',
                      ' {'
                    )),
                  (e += A(t)),
                  i && (e += '}'),
                  t[2] && (e += '}'),
                  t[4] && (e += '}'),
                  e
                );
              }).join('');
            }),
            (t.i = function (A, e, i, o, n) {
              'string' == typeof A && (A = [[null, A, void 0]]);
              var l = {};
              if (i)
                for (var s = 0; s < this.length; s++) {
                  var a = this[s][0];
                  null != a && (l[a] = !0);
                }
              for (var r = 0; r < A.length; r++) {
                var d = [].concat(A[r]);
                (i && l[d[0]]) ||
                  (void 0 !== n &&
                    (void 0 === d[5] ||
                      (d[1] = '@layer'
                        .concat(d[5].length > 0 ? ' '.concat(d[5]) : '', ' {')
                        .concat(d[1], '}')),
                    (d[5] = n)),
                  e &&
                    (d[2]
                      ? ((d[1] = '@media '
                          .concat(d[2], ' {')
                          .concat(d[1], '}')),
                        (d[2] = e))
                      : (d[2] = e)),
                  o &&
                    (d[4]
                      ? ((d[1] = '@supports ('
                          .concat(d[4], ') {')
                          .concat(d[1], '}')),
                        (d[4] = o))
                      : (d[4] = ''.concat(o))),
                  t.push(d));
              }
            }),
            t
          );
        };
      },
      4417: (A) => {
        'use strict';
        A.exports = function (A, t) {
          return (
            t || (t = {}),
            A
              ? ((A = String(A.__esModule ? A.default : A)),
                /^['"].*['"]$/.test(A) && (A = A.slice(1, -1)),
                t.hash && (A += t.hash),
                /["'() \t\n]|(%20)/.test(A) || t.needQuotes
                  ? '"'.concat(
                      A.replace(/"/g, '\\"').replace(/\n/g, '\\n'),
                      '"'
                    )
                  : A)
              : A
          );
        };
      },
      1601: (A) => {
        'use strict';
        A.exports = function (A) {
          return A[1];
        };
      },
      176: (A, t, e) => {
        'use strict';
        e.d(t, { A: () => v });
        var i =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function (A) {
                  return typeof A;
                }
              : function (A) {
                  return A &&
                    'function' == typeof Symbol &&
                    A.constructor === Symbol &&
                    A !== Symbol.prototype
                    ? 'symbol'
                    : typeof A;
                },
          o = window.device,
          n = {},
          l = [];
        window.device = n;
        var s = window.document.documentElement,
          a = window.navigator.userAgent.toLowerCase(),
          r = [
            'googletv',
            'viera',
            'smarttv',
            'internet.tv',
            'netcast',
            'nettv',
            'appletv',
            'boxee',
            'kylo',
            'roku',
            'dlnadoc',
            'pov_tv',
            'hbbtv',
            'ce-html',
          ];
        function d(A, t) {
          return -1 !== A.indexOf(t);
        }
        function c(A) {
          return d(a, A);
        }
        function h(A) {
          return s.className.match(new RegExp(A, 'i'));
        }
        function p(A) {
          var t = null;
          h(A) ||
            ((t = s.className.replace(/^\s+|\s+$/g, '')),
            (s.className = t + ' ' + A));
        }
        function u(A) {
          h(A) && (s.className = s.className.replace(' ' + A, ''));
        }
        function m() {
          n.landscape()
            ? (u('portrait'), p('landscape'), y('landscape'))
            : (u('landscape'), p('portrait'), y('portrait')),
            w();
        }
        function y(A) {
          for (var t = 0; t < l.length; t++) l[t](A);
        }
        (n.macos = function () {
          return c('mac');
        }),
          (n.ios = function () {
            return n.iphone() || n.ipod() || n.ipad();
          }),
          (n.iphone = function () {
            return !n.windows() && c('iphone');
          }),
          (n.ipod = function () {
            return c('ipod');
          }),
          (n.ipad = function () {
            var A =
              'MacIntel' === navigator.platform && navigator.maxTouchPoints > 1;
            return c('ipad') || A;
          }),
          (n.android = function () {
            return !n.windows() && c('android');
          }),
          (n.androidPhone = function () {
            return n.android() && c('mobile');
          }),
          (n.androidTablet = function () {
            return n.android() && !c('mobile');
          }),
          (n.blackberry = function () {
            return c('blackberry') || c('bb10');
          }),
          (n.blackberryPhone = function () {
            return n.blackberry() && !c('tablet');
          }),
          (n.blackberryTablet = function () {
            return n.blackberry() && c('tablet');
          }),
          (n.windows = function () {
            return c('windows');
          }),
          (n.windowsPhone = function () {
            return n.windows() && c('phone');
          }),
          (n.windowsTablet = function () {
            return n.windows() && c('touch') && !n.windowsPhone();
          }),
          (n.fxos = function () {
            return (c('(mobile') || c('(tablet')) && c(' rv:');
          }),
          (n.fxosPhone = function () {
            return n.fxos() && c('mobile');
          }),
          (n.fxosTablet = function () {
            return n.fxos() && c('tablet');
          }),
          (n.meego = function () {
            return c('meego');
          }),
          (n.cordova = function () {
            return window.cordova && 'file:' === location.protocol;
          }),
          (n.nodeWebkit = function () {
            return 'object' === i(window.process);
          }),
          (n.mobile = function () {
            return (
              n.androidPhone() ||
              n.iphone() ||
              n.ipod() ||
              n.windowsPhone() ||
              n.blackberryPhone() ||
              n.fxosPhone() ||
              n.meego()
            );
          }),
          (n.tablet = function () {
            return (
              n.ipad() ||
              n.androidTablet() ||
              n.blackberryTablet() ||
              n.windowsTablet() ||
              n.fxosTablet()
            );
          }),
          (n.desktop = function () {
            return !n.tablet() && !n.mobile();
          }),
          (n.television = function () {
            for (var A = 0; A < r.length; ) {
              if (c(r[A])) return !0;
              A++;
            }
            return !1;
          }),
          (n.portrait = function () {
            return screen.orientation &&
              Object.prototype.hasOwnProperty.call(
                window,
                'onorientationchange'
              )
              ? d(screen.orientation.type, 'portrait')
              : n.ios() &&
                Object.prototype.hasOwnProperty.call(window, 'orientation')
              ? 90 !== Math.abs(window.orientation)
              : window.innerHeight / window.innerWidth > 1;
          }),
          (n.landscape = function () {
            return screen.orientation &&
              Object.prototype.hasOwnProperty.call(
                window,
                'onorientationchange'
              )
              ? d(screen.orientation.type, 'landscape')
              : n.ios() &&
                Object.prototype.hasOwnProperty.call(window, 'orientation')
              ? 90 === Math.abs(window.orientation)
              : window.innerHeight / window.innerWidth < 1;
          }),
          (n.noConflict = function () {
            return (window.device = o), this;
          }),
          n.ios()
            ? n.ipad()
              ? p('ios ipad tablet')
              : n.iphone()
              ? p('ios iphone mobile')
              : n.ipod() && p('ios ipod mobile')
            : n.macos()
            ? p('macos desktop')
            : n.android()
            ? n.androidTablet()
              ? p('android tablet')
              : p('android mobile')
            : n.blackberry()
            ? n.blackberryTablet()
              ? p('blackberry tablet')
              : p('blackberry mobile')
            : n.windows()
            ? n.windowsTablet()
              ? p('windows tablet')
              : n.windowsPhone()
              ? p('windows mobile')
              : p('windows desktop')
            : n.fxos()
            ? n.fxosTablet()
              ? p('fxos tablet')
              : p('fxos mobile')
            : n.meego()
            ? p('meego mobile')
            : n.nodeWebkit()
            ? p('node-webkit')
            : n.television()
            ? p('television')
            : n.desktop() && p('desktop'),
          n.cordova() && p('cordova'),
          (n.onChangeOrientation = function (A) {
            'function' == typeof A && l.push(A);
          });
        var g = 'resize';
        function M(A) {
          for (var t = 0; t < A.length; t++) if (n[A[t]]()) return A[t];
          return 'unknown';
        }
        function w() {
          n.orientation = M(['portrait', 'landscape']);
        }
        Object.prototype.hasOwnProperty.call(window, 'onorientationchange') &&
          (g = 'orientationchange'),
          window.addEventListener
            ? window.addEventListener(g, m, !1)
            : window.attachEvent
            ? window.attachEvent(g, m)
            : (window[g] = m),
          m(),
          (n.type = M(['mobile', 'tablet', 'desktop'])),
          (n.os = M([
            'ios',
            'iphone',
            'ipad',
            'ipod',
            'android',
            'blackberry',
            'macos',
            'windows',
            'fxos',
            'meego',
            'television',
          ])),
          w();
        const v = n;
      },
      3915: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i = `<div class="ad-container"> <span>广告</span> <img class="close" src="${new URL(
          e(5503),
          e.b
        )}"> <a class="ad-wrapper" target="_blank"> <img class="ad"> </a> </div>`;
      },
      5490: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => g });
        var i = e(5072),
          o = e.n(i),
          n = e(7825),
          l = e.n(n),
          s = e(7659),
          a = e.n(s),
          r = e(5056),
          d = e.n(r),
          c = e(540),
          h = e.n(c),
          p = e(1113),
          u = e.n(p),
          m = e(1305),
          y = {};
        (y.styleTagTransform = u()),
          (y.setAttributes = d()),
          (y.insert = a().bind(null, 'head')),
          (y.domAPI = l()),
          (y.insertStyleElement = h()),
          o()(m.A, y);
        const g = m.A && m.A.locals ? m.A.locals : void 0;
      },
      5072: (A) => {
        'use strict';
        var t = [];
        function e(A) {
          for (var e = -1, i = 0; i < t.length; i++)
            if (t[i].identifier === A) {
              e = i;
              break;
            }
          return e;
        }
        function i(A, i) {
          for (var n = {}, l = [], s = 0; s < A.length; s++) {
            var a = A[s],
              r = i.base ? a[0] + i.base : a[0],
              d = n[r] || 0,
              c = ''.concat(r, ' ').concat(d);
            n[r] = d + 1;
            var h = e(c),
              p = {
                css: a[1],
                media: a[2],
                sourceMap: a[3],
                supports: a[4],
                layer: a[5],
              };
            if (-1 !== h) t[h].references++, t[h].updater(p);
            else {
              var u = o(p, i);
              (i.byIndex = s),
                t.splice(s, 0, { identifier: c, updater: u, references: 1 });
            }
            l.push(c);
          }
          return l;
        }
        function o(A, t) {
          var e = t.domAPI(t);
          return (
            e.update(A),
            function (t) {
              if (t) {
                if (
                  t.css === A.css &&
                  t.media === A.media &&
                  t.sourceMap === A.sourceMap &&
                  t.supports === A.supports &&
                  t.layer === A.layer
                )
                  return;
                e.update((A = t));
              } else e.remove();
            }
          );
        }
        A.exports = function (A, o) {
          var n = i((A = A || []), (o = o || {}));
          return function (A) {
            A = A || [];
            for (var l = 0; l < n.length; l++) {
              var s = e(n[l]);
              t[s].references--;
            }
            for (var a = i(A, o), r = 0; r < n.length; r++) {
              var d = e(n[r]);
              0 === t[d].references && (t[d].updater(), t.splice(d, 1));
            }
            n = a;
          };
        };
      },
      7659: (A) => {
        'use strict';
        var t = {};
        A.exports = function (A, e) {
          var i = (function (A) {
            if (void 0 === t[A]) {
              var e = document.querySelector(A);
              if (
                window.HTMLIFrameElement &&
                e instanceof window.HTMLIFrameElement
              )
                try {
                  e = e.contentDocument.head;
                } catch (A) {
                  e = null;
                }
              t[A] = e;
            }
            return t[A];
          })(A);
          if (!i)
            throw new Error(
              "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
            );
          i.appendChild(e);
        };
      },
      540: (A) => {
        'use strict';
        A.exports = function (A) {
          var t = document.createElement('style');
          return A.setAttributes(t, A.attributes), A.insert(t, A.options), t;
        };
      },
      5056: (A, t, e) => {
        'use strict';
        A.exports = function (A) {
          var t = e.nc;
          t && A.setAttribute('nonce', t);
        };
      },
      7825: (A) => {
        'use strict';
        A.exports = function (A) {
          if ('undefined' == typeof document)
            return { update: function () {}, remove: function () {} };
          var t = A.insertStyleElement(A);
          return {
            update: function (e) {
              !(function (A, t, e) {
                var i = '';
                e.supports && (i += '@supports ('.concat(e.supports, ') {')),
                  e.media && (i += '@media '.concat(e.media, ' {'));
                var o = void 0 !== e.layer;
                o &&
                  (i += '@layer'.concat(
                    e.layer.length > 0 ? ' '.concat(e.layer) : '',
                    ' {'
                  )),
                  (i += e.css),
                  o && (i += '}'),
                  e.media && (i += '}'),
                  e.supports && (i += '}');
                var n = e.sourceMap;
                n &&
                  'undefined' != typeof btoa &&
                  (i += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
                    btoa(unescape(encodeURIComponent(JSON.stringify(n)))),
                    ' */'
                  )),
                  t.styleTagTransform(i, A, t.options);
              })(t, A, e);
            },
            remove: function () {
              !(function (A) {
                if (null === A.parentNode) return !1;
                A.parentNode.removeChild(A);
              })(t);
            },
          };
        };
      },
      1113: (A) => {
        'use strict';
        A.exports = function (A, t) {
          if (t.styleSheet) t.styleSheet.cssText = A;
          else {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(A));
          }
        };
      },
      7214: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:image/svg+xml;base64,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';
      },
      2322: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiID4KPCEtLQoyMDEzLTktMzA6IENyZWF0ZWQuCi0tPgo8c3ZnPgo8bWV0YWRhdGE+CkNyZWF0ZWQgYnkgaWNvbmZvbnQKPC9tZXRhZGF0YT4KPGRlZnM+Cgo8Zm9udCBpZD0iaWNvbmZvbnQiIGhvcml6LWFkdi14PSIxMDI0IiA+CiAgPGZvbnQtZmFjZQogICAgZm9udC1mYW1pbHk9Imljb25mb250IgogICAgZm9udC13ZWlnaHQ9IjUwMCIKICAgIGZvbnQtc3RyZXRjaD0ibm9ybWFsIgogICAgdW5pdHMtcGVyLWVtPSIxMDI0IgogICAgYXNjZW50PSI4OTYiCiAgICBkZXNjZW50PSItMTI4IgogIC8+CiAgICA8bWlzc2luZy1nbHlwaCAvPgogICAgCiAgICA8Z2x5cGggZ2x5cGgtbmFtZT0iYXJyb3dkb3duLWNvcHkiIHVuaWNvZGU9IiYjNTg5MTU7IiBkPSJNNzI2LjY1MyA0NjYuNjk0aC00MjkuMzA2bDIxNC44NDYtMjA4Ljg1MXoiICBob3Jpei1hZHYteD0iMTAyNCIgLz4KCiAgICAKICAgIDxnbHlwaCBnbHlwaC1uYW1lPSJwbGF5IiB1bmljb2RlPSImIzU5MTc0OyIgZD0iTTUxMiA4NTMuMzMyOTkyQzI1NC43MzMzMTIgODUzLjMzMjk5MiA0Mi42NjU5ODQgNjQxLjI2MzYxNiA0Mi42NjU5ODQgMzg0czIxMi4wNjczMjgtNDY5LjMzMTk2OCA0NjkuMzMxOTY4LTQ2OS4zMzE5NjhjMjU3LjI2NDY0IDAgNDY5LjMzNDAxNiAyMTIuMDY3MzI4IDQ2OS4zMzQwMTYgNDY5LjMzMTk2OCAwIDI1Ny4yNjQ2NC0yMTIuMDY5Mzc2IDQ2OS4zMzQwMTYtNDY5LjMzNDAxNiA0NjkuMzM0MDE2TTUxMi0xMjhDMjI4LjY5Mjk5Mi0xMjggMCAxMDAuNjkyOTkyIDAgMzg0IDAgNjY3LjMwNzAwOCAyMjguNjkyOTkyIDg5NiA1MTIgODk2YzI4My4zMDcwMDggMCA1MTItMjI4LjY5Mjk5MiA1MTItNTEyIDAtMjgzLjMwNzAwOC0yMjguNjkyOTkyLTUxMi01MTItNTEyTTYzMS44ODM3NzYgMzk5Ljg5NzZjMTAuNjE4ODgtNy45NDkzMTIgMTAuNjE4ODgtMjMuODQ2OTEyIDAtMzEuNzk1Mkw0MDUuMjM3NzYgMjE3LjA2NzUyQzM5NC42MTg4OCAyMDkuMTE5MjMyIDM4NCAyMTQuNDE3NDA4IDM4NCAyMjcuNjY1OTJWNTQwLjMzMjAzMmMwIDEzLjI0OTUzNiAxMC42MTk5MDQgMTguNTQ4NzM2IDIxLjIzNzc2IDEwLjYwMDQ0OGwyMjYuNjQ2MDE2LTE1MS4wMzQ4OHoiICBob3Jpei1hZHYteD0iMTAyNSIgLz4KCiAgICAKCgogIDwvZm9udD4KPC9kZWZzPjwvc3ZnPgo=';
      },
      5503: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpCNzdDNzkwNTE1MjA2ODExODIyQTg3RDcyQkRGNjk2MiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3Rjg1NzQ2NDY0MjYxMUU2ODk0QUZBRTg4N0Y5MDgxRCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3Rjg1NzQ2MzY0MjYxMUU2ODk0QUZBRTg4N0Y5MDgxRCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OUU0MTk5OEUxRTIwNjgxMTgyMkE4N0Q3MkJERjY5NjIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Qjc3Qzc5MDUxNTIwNjgxMTgyMkE4N0Q3MkJERjY5NjIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7gi5EfAAABEklEQVR42qyUTQ6CMBCFW004hLrSU3gL/zd6Cb0AsJSt3kIT40lcG2N0oXdQN/W9pJgKLT/iSz5Spp0HZcpIpZSwyAM9TRc0wAvcwAHswF7HvkXDBH1wUvnimkEy37ypg6Uqr6XOTRn+YmaafhmOVHXRQ0hcWIAzaIlquoN2DZdx0iwIAiGlFGEYprIY4xzXJNQEE253Y3t/3/d5nhQSPzGOGeOcQ1saXl2zpmkBM+pKw0fWiti0gBn1rFlPuyF+L9vYKbgeXY8zt2n7pq4tb/LMsgplK8q0iFlB09m/D3YnLspCVNccPM3mEFX4jyNX+1r9YLZ2ta+YYYkGO8pqsCaerv4WXMBLc9GxqV6Tyn0LMACAi/Wdy4svogAAAABJRU5ErkJggg==';
      },
      9379: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAAApJJREFUeAHt2T9OwzAUBvAatTC1lZIwsTJzAC7ACTgBLEhdOjGWDSYWVsQB6AVgR2wsCAkhsTI1ttQyIP4I87nCkpEiVJU0fkEfQ506afv847n2axoN/lGAAhSgAAUoQAEKUIACFKAABShAAQpQgAIUmFVAzXpheF2e5z2l1EuSJGdobXgu5vEozwtjWc2yucbpxrI0z4CsUtmntafamCtjzMY871GX18wF5Adnrd0E1M1I6+ORtW3f/5/aPwE5CCA18dBXxtxrrbf/E44by5+BPAig1pBN57nWF+PxeN33170tDchDAGrr7f39Dtk0wPGK769rWzrQN8QKsukA2eSgtuqK4+JeFJA3WQfUBaDOsTVY8511ahcNNLXAVHNf3u5LvI/jJoEKBLCDayObjnNjbgC1WXCJyK5KMujHyK3dANYV9k6nk8kk/XFO4JPqgYCAaabwsIPV7gHZtDN9LhDHhRQFyFsAJsW0E12yRAUKoMSWLCKAHNR0dRNYsogBCrJJVMkiDiiAElGyiAX6hopeskgH8gkVrZW+7X9tKHWUJckhftp9jaEkFgggl61ms9ftdh9jwPjPFAcEmCf8wt5P03Tog4zZigECzAdqtBObJINMqeeYKOFniwACzvWSUnu4jXQbBifhOCoQYDSm0760+2vhPyYKEGAsptPZcqu13+l0dBiQtOPqgZS6RdbsZWl6LQ2jKJ7KgIDyjMwZYDqdoP0oCkZiXyVAABm6m4tYup8kIvwW06KBHrE69QBz+VsQks8tCih6iVAWeulAmE4iSgRxQIARVSKIAXIrksQSQQQQcMSWCFGBsA/OgbMruUQoC4jvQwEKUIACFKAABShAAQpQgAIUoAAFKEABClBgdoEvgRgNiNlEUbkAAAAASUVORK5CYII=';
      },
      5029: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:application/vnd.ms-fontobject;base64,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';
      },
      4427: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:font/ttf;base64,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';
      },
      1961: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:application/vnd.ms-fontobject;base64,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';
      },
      6999: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:font/ttf;base64,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';
      },
      3655: (A, t, e) => {
        'use strict';
        e.r(t), e.d(t, { default: () => i });
        const i =
          'data:font/woff;base64,d09GRgABAAAAAARoAAsAAAAABswAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABCAAAADMAAABCsP6z7U9TLzIAAAE8AAAARAAAAFY8mUkYY21hcAAAAYAAAABWAAABhmkn0RRnbHlmAAAB2AAAAJEAAACsoFCg7WhlYWQAAAJsAAAALwAAADYU+6wjaGhlYQAAApwAAAAeAAAAJAfeA4VobXR4AAACvAAAAAwAAAAMDAEAAGxvY2EAAALIAAAACAAAAAgADgBWbWF4cAAAAtAAAAAeAAAAIAEQADBuYW1lAAAC8AAAAUUAAAJtPlT+fXBvc3QAAAQ4AAAALgAAAD/D5yXjeJxjYGRgYOBikGPQYWB0cfMJYeBgYGGAAJAMY05meiJQDMoDyrGAaQ4gZoOIAgCKIwNPAHicY2BkYWCcwMDKwMHUyXSGgYGhH0IzvmYwYuRgYGBiYGVmwAoC0lxTGByeKT9XY27438AQw9zA0AAUZgTJAQDi6gwteJztkMENgDAMAy9p6QOxBRLiwUC8GJ+OUdwUtsDSxYqTl4EJSOIQGezC6DqVWuSJOfIcP0Vu+L3WrTX4XDLdSrhrFH4tMfd3897WoDdbtwH+ADzlDm4AAHicTYu7DcIwGITvt/FDjiIEQnFtRTItBQTmQGIBJskWbOQeUURykyI7pEKGP12uuu8eILDEQB8IgIIXQ7kzvZdYAr9+A9mjgkfLvYZp4DtcI2TEkQ2jhmwOW9Lxsjt3XiCVWSlyKZFTqswpl5E55EyBeXxaO9m6tvKxlKvx97RaZX6JyuzNSxtHN2c0/rNfLF8AAAB4nGNgZGBgAGLxnctexvPbfGXgZmEAgRvvTIQR9P8GFgbmBiCXg4EJJAoAMOgKOgB4nGNgZGBgbvjfwBDDAmQxMLAwMIBpJMAMAEciAm0AAAQAAAAEAAAABAEAAAAAAAAADgBWeJxjYGRgYGBmUAFiEGACYi4gZGD4D+YzAAAMZAFBAAB4nGWPTU7DMBCFX/oHpBKqqGCH5AViASj9EatuWFRq911036ZOmyqJI8et1ANwHo7ACTgC3IA78EgnmzaWx9+8eWNPANzgBx6O3y33kT1cMjtyDRe4F65TfxBukF+Em2jjVbhF/U3YxzOmwm10YXmD17hi9oR3YQ8dfAjXcI1P4Tr1L+EG+Vu4iTv8CrfQ8erCPuZeV7iNRy/2x1YvnF6p5UHFockikzm/gple75KFrdLqnGtbxCZTg6BfSVOdaVvdU+zXQ+ciFVmTqgmrOkmMyq3Z6tAFG+fyUa8XiR6EJuVYY/62xgKOcQWFJQ6MMUIYZIjK6Og7VWb0r7FDwl57Vj3N53RbFNT/c4UBAvTPXFO6stJ5Ok+BPV8bUnV0K27LnpQ0kV7NSRKyQl7WtlRC6gE2ZVeOEXpc0Yk/KGdI/wAJWm7IAAAAeJxjYGKAAC4G7ICZkYmRmZGFgS+xqCi/PCW/PE83Ob+gkqUgJ7GSgQEAYa8HrwAA';
      },
      9099: (A) => {
        'use strict';
        A.exports =
          'data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAALoAAsAAAAABswAAAKZAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCDBgqBLIEoATYCJAMMCwgABCAFhG0HPxv3BciemjwJBBawWJiKrz0ASDwe/hv7dt/MfNW2KmnPdtG6CbVE49AhkkRLp5FIhAwheQn/z+kv/1pWQYEwj7X+Uuyl/nTcdSTtTi8NcwkH30gwCtRYSyHREE3ufj9P1OLQShNpd5+4d/rneReO/SzLZW3rorEmfwww7rwLcKxFEQ2RQLxh7AKXcJhA07wmodOhiRQqVFijAvHU1GVUmAsrCsvVhWrNwiLeqKinV+kQr8Pvx397KSSpZNbEyyeDGur5VflDWJ2tols+IUKAyyvI2IUU4k5t+hpBML6gaRfbS6uKkOaK/T+hXndWd/rHS0SVVd0Gm9CWbsrgqgh+00EB8vtVFGxALmYoJOTctiY+K0kvXH6mrr7SNz/Z6+9Zx5qJtFlNxSWTO6vj1HYuhJefJ9ftXh9abHpfLGqU77bG13rmtKH98PROBBAh724RzHCxLE2XTr/nplZqkQ6eox7Wz9KPuBAIal+/fLw7HX+FxQX8PFYXDpmtiii/QP1UnuDXdSohKNxkuXJR7VqrA9nqbYxMaGpihrB/6Hm8c9K7mlA3SZHUzCGrWyULu4uKln1U1R2gacfw8pYRRhClgW1bAKFvD0nXN2R9R2Rhn1Ax9YuqfgQ0XYmyDVvWY0r9DMsca6DMgalSjzhuLkW1CaxPOTLLmkJpBrPAjEEsHC3mhrGH2RxTgmk9zjkBwqgLQ+A47DgUfEYtrPKwwbnfFomQuheFVeoiyQkGk3GYBijmAJOK8hC/NSeVPp+A6aY4ZKyFU1PPwJiA2T2ICYv2IIftXi/OvTwTmKaL4zgCEAzlAkOgH+ZwUMCv72fBVFyYMSLpaxOxm5G+9vD6Tvf7tkGTNSlHihxF9z5jdEZzenvNKvXnRN+R5xACAAAA';
      },
      396: (A) => {
        'use strict';
        A.exports =
          'data:application/x-font-woff;charset=utf-8;base64,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';
      },
    },
    t = {};
  function e(i) {
    var o = t[i];
    if (void 0 !== o) return o.exports;
    var n = (t[i] = { id: i, exports: {} });
    return A[i].call(n.exports, n, n.exports, e), n.exports;
  }
  (e.m = A),
    (e.n = (A) => {
      var t = A && A.__esModule ? () => A.default : () => A;
      return e.d(t, { a: t }), t;
    }),
    (e.d = (A, t) => {
      for (var i in t)
        e.o(t, i) &&
          !e.o(A, i) &&
          Object.defineProperty(A, i, { enumerable: !0, get: t[i] });
    }),
    (e.o = (A, t) => Object.prototype.hasOwnProperty.call(A, t)),
    (e.r = (A) => {
      'undefined' != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(A, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(A, '__esModule', { value: !0 });
    }),
    (e.b = document.baseURI || self.location.href),
    (e.nc = void 0),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(631),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(3446),
        y = e(3525),
        g = {};
      (g.styleTagTransform = h()),
        (g.setAttributes = a()),
        (g.insert = l().bind(null, 'head')),
        (g.domAPI = o()),
        (g.insertStyleElement = d()),
        t()(y.A, g),
        y.A && y.A.locals && y.A.locals;
      var M = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.AliplayerDanmuComponent = class {
          constructor(A) {
            let t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 'controlbar';
            (this.sendEl = t),
              (this.danmukuList = A),
              (this.html = (0, M.a8)(
                '<div class="aliplayer-danmuku abp"> <div class="danmu container"></div> </div>'
              )),
              (this.danmuControlHtml = (0, M.a8)(
                '<div class="ali-danmuku-control"> <div class="ali-danmu-input-wrap"></div> <i class="iconfont icon-danmu-close"></i> <div class="player-tooltip close"></div> <i class="iconfont icon-danmu-open" style="display:none"></i> <div class="player-tooltip open"></div> </div>'
              )),
              (this.sendEl = t),
              (this.danmuInput =
                null === t
                  ? null
                  : (0, M.a8)(
                      '<div class="ali-danmu-input"> <input type="text" placeholder=""> <button class="danmu-input-enter"></button> </div>'
                    )),
              (this.CM = null),
              (this.userDanmuOpen = !0);
          }
          createEl(A, t) {
            console.log(t);
            const e = t._options && t._options.language;
            if (
              ((this.isEn = e && 'en-us' === e),
              null !== this.danmuInput &&
                ((this.danmuInput.querySelector(
                  '.danmu-input-enter'
                ).innerText = this.isEn ? 'Enter' : '发送'),
                this.danmuInput
                  .querySelector('input')
                  .setAttribute(
                    'placeholder',
                    this.isEn ? 'Input danmu' : '输入弹幕'
                  )),
              (this.danmuControlHtml.querySelector(
                '.player-tooltip.close'
              ).innerText = this.isEn ? 'Close Bullect' : '关闭弹幕'),
              (this.danmuControlHtml.querySelector(
                '.player-tooltip.open'
              ).innerText = this.isEn ? 'Open Bullect' : '打开弹幕'),
              'controlbar' === this.sendEl)
            ) {
              let A = this.danmuControlHtml.querySelector(
                '.ali-danmu-input-wrap'
              );
              (A.style.display = 'inline-block'),
                A.appendChild(this.danmuInput);
            } else if (null !== this.sendEl)
              if ((0, M.vq)(this.sendEl))
                this.sendEl.appendChild(this.danmuInput);
              else {
                if ('string' != typeof this.sendEl)
                  throw new Error(
                    'sendEl must be an element or selector string'
                  );
                {
                  let A = document.querySelector(this.sendEl);
                  if (!(0, M.vq)(A))
                    throw new Error(
                      'sendEl must be an element or selector string'
                    );
                  A.appendChild(this.danmuInput);
                }
              }
            A.querySelector('.prism-controlbar').appendChild(
              this.danmuControlHtml
            );
            let i = A.querySelector('video').nextElementSibling;
            i ? A.insertBefore(this.html, i) : A.appendChild(this.html),
              (this.CM = new m.CommentManager(
                this.html.querySelector('.danmu')
              )),
              this.CM.init(),
              this.CM.load(this.danmukuList),
              (A.querySelector('video').ontimeupdate = () => {
                null !== A.querySelector('video') &&
                  this.CM.time(1e3 * A.querySelector('video').currentTime);
              });
            let o = this.danmuControlHtml.querySelector('.icon-danmu-close'),
              n = this.danmuControlHtml.querySelector('.icon-danmu-open');
            if (
              ((o.onclick = () => {
                (this.userDanmuOpen = !1),
                  (o.style.display = 'none'),
                  (n.style.display = 'inline-block'),
                  this.CM.clear(),
                  this.CM.stop();
              }),
              (n.onclick = () => {
                (n.style.display = 'none'),
                  (o.style.display = 'inline-block'),
                  (this.userDanmuOpen = !0),
                  this.CM.start();
              }),
              null !== this.danmuInput)
            ) {
              let A = this.danmuInput.querySelector('.ali-danmu-input input');
              (this.danmuInput.querySelector(
                '.danmu-input-enter'
              ).onclick = this.sendDanmuHandle.bind(this)),
                (A.onkeydown = (A) => {
                  13 === A.keyCode && this.sendDanmuHandle.call(this);
                });
            }
          }
          sendDanmuHandle() {
            let A = this.danmuInput.querySelector('.ali-danmu-input input'),
              t = A.value;
            '' !== t &&
              (this.send({
                mode: 1,
                text: t,
                stime: 1e3,
                size: [16, 18, 25, 36, 45][this.randomIndex(5)],
                color: [16777215, 255, 13369344, 16738047, 16777011][
                  this.randomIndex(5)
                ],
              }),
              (A.value = ''),
              A.focus());
          }
          randomIndex(A) {
            return Math.floor(Math.random() * A);
          }
          play(A, t) {
            this.userDanmuOpen && this.CM.start();
          }
          pause(A, t) {
            this.userDanmuOpen && this.CM.stop();
          }
          send(A) {
            this.CM.send(A);
          }
          insert(A) {
            this.CM && this.CM.insert(A);
          }
          dispose() {
            null !== this.danmuInput &&
              this.danmuInput.parentNode &&
              this.danmuInput.parentNode.removeChild(this.danmuInput);
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(2049),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.BulletScreenComponent = class {
          constructor(A, t) {
            let e =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : 'random';
            (this.text = A),
              (this.style = t || { fontSize: '14px', color: '#fff' }),
              (this.html = (0, m.a8)(
                '<div class="bullet-screen paused"></div>'
              )),
              (this.bulletPosition = e);
          }
          createEl(A, t) {
            (this.html.innerText = this.text),
              A.appendChild(this.html),
              (A.style.overflow = 'hidden');
          }
          ready(A, t) {
            console.log(A.getOptions()),
              !1 === A.getOptions().autoplay &&
                (this.html.style.animationPlayState = 'paused'),
              Object.keys(this.style).forEach(
                (A) => (this.html.style[A] = this.style[A])
              );
            var e = this.html.offsetHeight,
              i =
                parseInt(getComputedStyle(A.tag).height.replace('px', '')) - e;
            if ('bottom' === this.bulletPosition) this.html.style.bottom = 0;
            else {
              let A = 'top' === this.bulletPosition ? 0 : this.randomTop(i);
              this.html.style.top = A;
            }
            'random' === this.bulletPosition &&
              this.html.addEventListener('animationiteration', () => {
                this.html.style.top = this.randomTop(i);
              });
          }
          playing(A, t) {
            console.log('playering'),
              (this.html.style.animationPlayState = 'running');
          }
          timeupdate(A, t) {
            let e = A.el(),
              i = e.querySelector('.bullet-screen');
            if (i) {
              'bullet-screen' !== i.className &&
                (i.className = 'bullet-screen');
              let A = getComputedStyle(i),
                t = A.getPropertyValue('display'),
                e = A.getPropertyValue('opacity'),
                o = A.getPropertyValue('visibility'),
                n = this.text,
                l = i.innerText;
              'none' === t && i.style.setProperty('display', 'block'),
                '1' !== e && i.style.setProperty('opacity', '1'),
                'hidden' === o && i.style.setProperty('visibility', 'visible'),
                n != l && (i.innerText = n);
            } else e.appendChild(this.html);
          }
          pause(A, t) {
            console.log('pause'),
              (this.html.style.animationPlayState = 'paused');
          }
          randomTop(A) {
            return Math.floor(Math.random() * A) + 'px';
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(1209),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.CaptionComponent = class {
          constructor() {
            (this.captionList = null),
              (this.html = (0, m.a8)(
                '<div class="caption-components"> <div class="current-caption" data-ref=""></div> <ul class="caption-list"> </ul> </div>'
              )),
              (this.modalHtml = (0, m.a8)(
                '<div class="caption-modal prism-info-display prism-info-left-bottom"> <span class="switchimg"></span> <span class="current-caption-tag"></span> </div>'
              )),
              (this.hasCreated = !1),
              (this.definition = '');
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.modalHtml.querySelector('.switchimg').innerText = this.isEn
                ? 'Switching to you for'
                : '字幕切换到'),
              (this.modalHtml.querySelector('.switchimg').style.display =
                'none'),
              A.querySelector('.prism-controlbar').appendChild(this.html),
              A.appendChild(this.modalHtml),
              t.on('textTrackReady', (A) => {
                let { paramData: t } = A;
                this.captionList = t;
                let e = t.map(
                  (A) => `<li data-def="${A.value}">${A.text}</li>`
                );
                this.html.querySelector('.caption-list').innerHTML =
                  '<li style="background:rgba(88,87,86,.5);color:#fff">字幕</li>' +
                  e.join('');
              });
            let i = this.html.querySelector('.current-caption'),
              o = this.html.querySelector('.caption-list');
            0 == this.hasCreated &&
              this.definition &&
              (o.querySelector(`li[data-def="${this.definition}"]`).className =
                'current'),
              (this.hasCreated = !0);
            let n = null;
            (i.onclick = () => {
              o.style.display = 'block';
            }),
              (i.onmouseleave = () => {
                n = setTimeout(() => {
                  o.style.display = 'none';
                }, 100);
              }),
              (o.onmouseenter = () => {
                clearTimeout(n);
              }),
              (o.onmouseleave = () => {
                (o.style.display = 'none'),
                  (this.modalHtml.style.display = 'none');
              }),
              (o.onclick = (A) => {
                let { target: e } = A,
                  i = e.dataset.def;
                if (i && 'current' !== e.className) {
                  let A = Array.isArray(this.captionList)
                    ? this.captionList.filter((A) => A.value === i)[0]
                    : this.captionList.find((A) => A.value === i);
                  t._ccService.switch(A.value),
                    this.setCurrentCaption(A.text, A.value),
                    (this.modalHtml.style.display = 'block'),
                    (this.modalHtml.querySelector('.switchimg').style.display =
                      'block'),
                    (this.modalHtml.querySelector(
                      'span.current-caption-tag'
                    ).innerText = A.text);
                }
              });
          }
          setCurrentCaption(A, t) {
            let e = this.html.querySelector('.current-caption');
            (e.innerText = A), (e.dataset.def = t), (this.definition = t);
            let i = this.html.querySelector('.caption-list'),
              o = i.querySelector('.current');
            o && (o.className = '');
            let n = i.querySelectorAll('li');
            n.forEach((t) => {
              t.innerText === A && (t.className = 'current');
            }),
              n && (n.className = 'current');
          }
          created(A) {}
          ready(A) {
            this.modalHtml.style.display = 'none';
            let t = document.querySelector(
              '.prism-setting-item.prism-setting-cc'
            );
            t && t.classList.add('player-hidden');
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(6730),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52),
        y = e(176);
      let g = class {
        constructor(A, t) {
          let e =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : '关闭广告';
          (this.adVideoSource = A),
            (this.html = (0, m.a8)(
              '<div class="many-video-ad-component"> <div class="videos"> </div> <a class="many-video-ad-link" target="_blank"></a> <div class="many-video-ad-close"> <span id="many-video-ad-duration"></span> <label> <span class="many-video-ad-close-text"></span> <i class="iconfont icon-close"></i> </label> </div> <a class="many-video-ad-detail" target="_blank">查看详情</a> <div class="autoplay-many-video-ad"> <i class="iconfont icon-player-play"></i> <span class="limit"></span> <span class="manual"></span> </div> </div>'
            )),
            (this.adInterval = null),
            (this.adCloseFunction = t),
            (this.html.querySelector(
              '.many-video-ad-close-text'
            ).innerText = e),
            (this.adDuration = null),
            (this.player = null),
            (this.indexVideo = 1);
        }
        createEl(A, t) {
          const e = t._options && t._options.language;
          (this.isEn = e && 'en-us' === e),
            (this.html.querySelector('.many-video-ad-detail').innerText = this
              .isEn
              ? 'For more information'
              : '查看广告详情'),
            (this.html.querySelector('.limit').innerText = this.isEn
              ? 'Your browser limits autoplay'
              : '您的浏览器限制'),
            (this.html.querySelector('.manual').innerText = this.isEn
              ? 'Please Click'
              : '自动播放请点击'),
            A.appendChild(this.html);
        }
        created(A) {
          let t = this.adVideoSource.map(
            (A, t) =>
              `<video id="many-video-ad-content${t + 1}" style="${
                0 === t ? 'display: block' : 'display:none'
              };width:100%;height:100%" x5-video-player-type="h5" x5-video-player-fullscreen="false" src="${
                A.adVideo
              }"></video>`
          );
          (this.html.querySelector('.videos').innerHTML = t.join(' ')),
            (this.indexVideo = Number(this.indexVideo));
          let e = this.indexVideo,
            i = this.adVideoSource,
            o = this.html.querySelector(
              '#many-video-ad-content' + this.indexVideo
            ),
            n = this.html.querySelector('.many-video-ad-detail'),
            l = this.html.querySelector('#many-video-ad-duration'),
            s = this;
          var a = o.play();
          void 0 !== a &&
            a
              .then(() => {
                o.play();
              })
              .catch((A) => {
                (document.querySelector(
                  '.autoplay-many-video-ad'
                ).style.display = 'block'),
                  (o.oncanplay = () => {
                    let A = Math.ceil(o.duration);
                    document.querySelector(
                      '#many-video-ad-duration'
                    ).innerText = A;
                  });
              }),
            o.addEventListener('canplay', function A() {
              o.removeEventListener('canplay', A),
                (n.href = i[e - 1].adVideoLink),
                o
                  .play()
                  .then(() => {
                    let A = Math.ceil(o.duration);
                    (l.innerText = A), s.setAdInterval();
                  })
                  .catch((A) => {
                    (s.html.querySelector(
                      '.autoplay-many-video-ad'
                    ).style.display = 'block'),
                      (s.html.querySelector(
                        '.icon-player-play'
                      ).onclick = () => {
                        s.playManyVideoAd(),
                          (s.html.querySelector(
                            '.autoplay-many-video-ad'
                          ).style.display = 'none');
                      });
                  });
            });
        }
        ready(A, t) {
          this.indexVideo = Number(this.indexVideo);
          let e = this.html.querySelector(
              '#many-video-ad-content' + this.indexVideo
            ),
            i = this;
          e.addEventListener('ended', function (t) {
            '-1' == i.playNext(i) && A.play();
          }),
            (this.html.querySelector(
              '.many-video-ad-close label'
            ).onclick = () => {
              'function' == typeof this.adCloseFunction
                ? this.adCloseFunction(this)
                : this.closeManyVideoAd();
            });
        }
        setAdInterval(A) {
          let t = this.html.querySelector('#many-video-ad-duration'),
            e = this.html.querySelector(
              '#many-video-ad-content' + this.indexVideo
            );
          this.adInterval = setInterval(() => {
            let A = Math.ceil(e.duration) - Math.ceil(e.currentTime);
            (t.innerText = A), 1 == A && clearInterval(this.adInterval);
          }, 1e3);
        }
        pauseManyVideoAd() {
          this.clearAdInterval(),
            this.html
              .querySelector('#many-video-ad-content' + this.indexVideo)
              .pause();
        }
        playManyVideoAd() {
          this.setAdInterval(),
            this.html
              .querySelector('#many-video-ad-content' + this.indexVideo)
              .play();
        }
        clearAdInterval() {
          null !== this.adInterval && clearInterval(this.adInterval),
            (this.adInterval = null);
        }
        playNext(A) {
          if (A.indexVideo >= A.adVideoSource.length)
            return A.html.parentNode.removeChild(A.html), -1;
          (this.indexVideo = Number(this.indexVideo)),
            null !=
              document.getElementById(
                'many-video-ad-content' + this.indexVideo
              ) &&
              document
                .getElementById('many-video-ad-content' + this.indexVideo)
                .remove();
          let t = this.indexVideo + 1;
          A.html.querySelector('.many-video-ad-detail').href =
            A.adVideoSource[A.indexVideo].adVideoLink;
          let e = this.html.querySelector('#many-video-ad-content' + t),
            i = this.html.querySelector('#many-video-ad-duration');
          (e.style.display = 'block'),
            this.adVideoSource.length >= this.indexVideo &&
              (this.indexVideo = this.indexVideo + 1);
          let o = Math.ceil(e.duration);
          (i.innerText = o),
            A.setAdInterval(),
            e.play(),
            e.addEventListener('ended', function (t) {
              '-1' == A.playNext(A) &&
                document
                  .getElementById(player._options.id)
                  .getElementsByTagName('video')[0]
                  .play();
            });
        }
        closeManyVideoAd() {
          this.clearAdInterval(),
            this.html.parentNode.removeChild(this.html),
            (this.html = null),
            document
              .getElementById(player._options.id)
              .getElementsByTagName('video')[0]
              .play();
        }
      };
      y.A.mobile() &&
        (g = class {
          constructor(A, t) {
            let e =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : '关闭广告';
            (this.adVideoSource = A),
              (this.html = (0, m.a8)(
                '<div class="many-video-ad-component" style="background-color:transparent"> <div class="videosmb"></div> <a class="many-video-ad-link" target="_blank"></a> <div class="many-video-ad-close"> <span id="many-video-ad-duration"></span> <label> <span class="many-video-ad-close-text"></span> <i class="iconfont icon-close"></i> </label> </div> <a class="many-video-ad-detail" target="_blank"></a> <div class="autoplay-many-video-ad" style="display:block"> <i class="iconfont icon-player-play"></i> <span class="limit"></span> <span class="manual"></span> </div> </div>'
              )),
              (this.adInterval = null),
              (this.adCloseFunction = t),
              (this.html.querySelector(
                '.many-video-ad-close-text'
              ).innerText = e),
              (this.adDuration = null),
              (this.player = null),
              (this.indexVideo = 1);
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector('.many-video-ad-detail').innerText = this
                .isEn
                ? 'For more information'
                : '查看广告详情'),
              (this.html.querySelector('.limit').innerText = this.isEn
                ? 'Your browser limits autoplay'
                : '您的浏览器限制'),
              (this.html.querySelector('.manual').innerText = this.isEn
                ? 'Please Click'
                : '自动播放请点击'),
              A.appendChild(this.html),
              A.querySelector('.videosmb'),
              A.querySelector('.videosmb').setAttribute('preload', 'load');
            let i = A.querySelector('.prism-controlbar');
            (i.className = i.className + ' controlbar-element-hidden'),
              (this.html.querySelector('.icon-player-play').onclick = () => {
                this.playManyVideoAd(),
                  (this.html.querySelector(
                    '.autoplay-many-video-ad'
                  ).style.display = 'none');
              });
          }
          created(A) {
            let t = this.adVideoSource.map(
              (A, t) =>
                `<video id="many-video-ad-content${t + 1}" style="${
                  0 === t ? 'display: block' : 'display:none'
                };width:100%;height:100%" x5-video-player-type="h5" x5-video-player-fullscreen="false" src="${
                  A.adVideo
                }"></video>`
            );
            (this.html.querySelector('.videosmb').innerHTML = t.join(' ')),
              (this.indexVideo = Number(this.indexVideo));
            let e = this.indexVideo,
              i = this.adVideoSource,
              o = this.html.querySelector(
                '#many-video-ad-content' + this.indexVideo
              ),
              n = this.html.querySelector('.many-video-ad-detail'),
              l = this;
            o.addEventListener('canplay', function A() {
              o.removeEventListener('canplay', A),
                (n.href = i[e - 1].adVideoLink),
                (l.html.querySelector(
                  '#many-video-ad-duration'
                ).innerText = Math.ceil(o.duration));
            });
          }
          ready(A) {
            this.indexVideo = Number(this.indexVideo);
            let t = this.html.querySelector(
                '#many-video-ad-content' + this.indexVideo
              ),
              e = this;
            t.addEventListener('ended', function (t) {
              if ('-1' == e.playNext(e)) {
                A.play();
                let t = document.querySelector('.prism-controlbar');
                t.className = t.className.replace(
                  ' controlbar-element-hidden',
                  ''
                );
              }
            }),
              (this.html.querySelector(
                '.many-video-ad-close label'
              ).onclick = () => {
                'function' == typeof this.adCloseFunction
                  ? this.adCloseFunction(this)
                  : this.closeManyVideoAd();
              });
          }
          setAdInterval() {
            let A = this.html.querySelector('#many-video-ad-duration'),
              t = this.html.querySelector(
                '#many-video-ad-content' + this.indexVideo
              );
            this.adInterval = setInterval(() => {
              let e = Math.ceil(t.duration) - Math.ceil(t.currentTime);
              (A.innerText = e), 1 == e && clearInterval(this.adInterval);
            }, 1e3);
          }
          closeManyVideoAd() {
            this.clearAdInterval();
            let A = this.html.parentNode.querySelector('.prism-controlbar');
            (A.className = A.className.replace(
              ' controlbar-element-hidden',
              ''
            )),
              this.html.parentNode.removeChild(this.html),
              (this.html = null),
              document
                .getElementById(player._options.id)
                .getElementsByTagName('video')[0]
                .play();
          }
          clearAdInterval() {
            null !== this.adInterval && clearInterval(this.adInterval),
              (this.adInterval = null);
          }
          playManyVideoAd() {
            this.setAdInterval(),
              this.html
                .querySelector('#many-video-ad-content' + this.indexVideo)
                .play();
          }
          pauseManyVideoAd() {
            this.clearAdInterval(),
              this.html
                .querySelector('#many-video-ad-content' + this.indexVideo)
                .pause();
          }
          playNext(A) {
            if (A.indexVideo >= A.adVideoSource.length)
              return A.html.parentNode.removeChild(A.html), -1;
            (this.indexVideo = Number(this.indexVideo)),
              null !=
                document.getElementById(
                  'many-video-ad-content' + this.indexVideo
                ) &&
                document
                  .getElementById('many-video-ad-content' + this.indexVideo)
                  .remove();
            let t = this.indexVideo + 1;
            A.html.querySelector('.many-video-ad-detail').href =
              A.adVideoSource[A.indexVideo].adVideoLink;
            let e = this.html.querySelector('#many-video-ad-content' + t),
              i = this.html.querySelector('#many-video-ad-duration');
            (e.style.display = 'block'),
              this.adVideoSource.length >= this.indexVideo &&
                (this.indexVideo = this.indexVideo + 1);
            let o = Math.ceil(e.duration);
            (i.innerText = o),
              A.setAdInterval(),
              e.play(),
              e.addEventListener('ended', function (t) {
                if ('-1' == A.playNext(A)) {
                  document
                    .getElementById(player._options.id)
                    .getElementsByTagName('video')[0]
                    .play();
                  let A = document.querySelector('.prism-controlbar');
                  A.className = A.className.replace(
                    ' controlbar-element-hidden',
                    ''
                  );
                }
              });
          }
        });
      const M = g;
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.ManyVideoADComponent = M);
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(4078),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.MemoryPlayComponent = class {
          constructor() {
            let A =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = arguments.length > 1 ? arguments[1] : void 0,
              e = arguments.length > 2 ? arguments[2] : void 0;
            (this.html = (0, m.a8)('<div class="memory-play-wrap"></div>')),
              (this.autoPlay = A),
              (this.getTime = t || this._getTime),
              (this.saveTimeFunction = e || this._saveTime),
              (this.hasMemoryDisplay = !1);
          }
          createEl(A) {
            A.appendChild(this.html);
          }
          ready(A, t) {
            let e = A.getOptions(),
              i = e.vid || e.source.replace(/\?.*$/, ''),
              o = this.getTime(i);
            if (
              ((o = o ? parseInt(o) : 0),
              null !== o && 0 !== o && !this.hasMemoryDisplay)
            )
              if (((this.hasMemoryDisplay = !0), this.autoPlay))
                A.seek(o), 'playing' !== A.getStatus() && A.play();
              else {
                let t = this.getVideoTime(o);
                if (o !== parseInt(A._duration)) {
                  let e = `<div class="memory-play">\n          <i class="iconfont icon-close"></i>\n          <span>上次看到</span>\n          <span>${t}</span>\n          <span class="play-jump">跳转播放</span>\n          </div>`;
                  this.html.innerHTML = e;
                  let i = setTimeout(() => {
                    this.html.innerHTML = '';
                  }, 15e3);
                  (this.html.querySelector('.icon-close').onclick = () => {
                    (this.html.innerHTML = ''), clearTimeout(i);
                  }),
                    (this.html.querySelector('.play-jump').onclick = () => {
                      A.seek(o),
                        'playing' !== A.getStatus() && A.play(),
                        (this.html.innerHTML = ''),
                        clearTimeout(i);
                    });
                }
              }
            (document.onvisibilitychange = () => {
              'hidden' === document.visibilityState &&
                0 !== A.getCurrentTime() &&
                (this.saveTimeFunction(i, A.getCurrentTime()),
                console.log(play));
            }),
              (window.onbeforeunload = () => {
                0 !== A.getCurrentTime() &&
                  this.saveTimeFunction(i, A.getCurrentTime());
              });
          }
          error(A, t) {
            this.setMemory(A);
          }
          dispose(A, t) {
            this.setMemory(A);
          }
          setMemory(A) {
            let t = A.getOptions(),
              e = t.vid || t.source.replace(/\?.*$/, '');
            this.saveTimeFunction(e, A.getCurrentTime());
          }
          getVideoTime(A) {
            let t = Math.round(A),
              e = Math.floor(t / 3600),
              i = Math.floor((t - 3600 * e) / 60),
              o = t - 3600 * e - 60 * i;
            return (
              i < 10 && (i = '0' + i),
              o < 10 && (o = '0' + o),
              0 === e ? i + ':' + o : e + ':' + i + ':' + o
            );
          }
          _getTime(A) {
            return localStorage.getItem(A);
          }
          _saveTime(A, t) {
            localStorage.setItem(A, t);
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(2190),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.PauseADComponent = class {
          constructor(A, t) {
            (this.coverUrl = A),
              (this.adUrl = t),
              (this.html = (0, m.a8)(
                '<div class="pause-ad"> <a class="btn-close"> <i class="split-left"></i> <i class="split-right"></i> <a> <span class="ad-text"></span> <a class="ad-content" target="_blank"> <img/> </a> </a></a></div>'
              ));
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector('.ad-text').innerText = this.isEn
                ? 'Ad'
                : '广告');
            let i = this.html.querySelector('.ad-content'),
              o = i.querySelector('img');
            i.setAttribute('href', this.adUrl),
              o.setAttribute('src', this.coverUrl),
              (this.html.querySelector('.btn-close').onclick = () => {
                this.html.style.display = 'none';
              }),
              A.appendChild(this.html);
          }
          play(A, t) {
            this.html.style.display = 'none';
          }
          pause(A, t) {
            this.html.style.display = 'block';
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(4843),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.PlaylistComponent = class {
          constructor(A) {
            (this.controlHtml = (0, m.a8)(
              '<div class="playlist-component"> <i class="iconfont icon-skip-previous"></i> <div class="player-tooltip prev">上一个</div> <i class="iconfont icon-list"></i> <div class="player-tooltip list">播放列表</div> <i class="iconfont icon-skipnext"></i> <div class="player-tooltip next">下一个</div> </div>'
            )),
              (this.listHtml = (0, m.a8)(
                '<div class="playlist-content"> <div class="list"></div> </div>'
              )),
              (this.playlist = A),
              (this.playingVideoIndex = 0),
              (this.listHideTimeout = null);
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.controlHtml.querySelector(
                '.player-tooltip.prev'
              ).innerText = this.isEn ? 'Previous' : '上一个'),
              (this.controlHtml.querySelector(
                '.player-tooltip.list'
              ).innerText = this.isEn ? 'Playlist' : '播放列表'),
              (this.controlHtml.querySelector(
                '.player-tooltip.next'
              ).innerText = this.isEn ? 'Next' : '下一个');
            let i = A.querySelector('.prism-controlbar'),
              o = i.querySelector('.prism-time-display');
            i.insertBefore(this.controlHtml, o),
              (this.listHtml.onmouseleave = () => {
                this.listHtml.style.width = 0;
              }),
              (this.listHtml.onmouseenter = this.clearHideListTimeout.bind(
                this
              )),
              (this.controlHtml.querySelector(
                '.icon-list'
              ).onclick = this.tooglePlaylist.bind(this)),
              (this.listHtml.querySelector(
                '.list'
              ).innerHTML = this.computedListDom(this.playlist));
            let n = t.getOptions() && t.getOptions().source,
              l = 0;
            n &&
              ((l = this.playlist.findIndex((A) => A.source === n)),
              (l = l > -1 ? l : 0),
              (this.playingVideoIndex = l > -1 ? l : 0)),
              (this.listHtml.querySelector('.list').childNodes[0].className =
                'video-item active'),
              A.appendChild(this.listHtml);
          }
          ready(A, t) {
            (this.controlHtml.querySelector(
              '.icon-skip-previous'
            ).onclick = () => {
              A &&
                A.trigger('plugin-playlist-click-prev', {
                  currentIndex: Math.max(this.playingVideoIndex - 1, 0),
                }),
                0 !== this.playingVideoIndex
                  ? this.playVideo(A, this.playingVideoIndex - 1)
                  : this.playlistTip(
                      this.isEn ? 'Already the first one~' : '已经是第一个了~',
                      A._el
                    );
            }),
              (this.controlHtml.querySelector(
                '.icon-skipnext'
              ).onclick = () => {
                A &&
                  A.trigger('plugin-playlist-click-next', {
                    currentIndex: Math.min(
                      this.playingVideoIndex + 1,
                      this.playlist.length - 1
                    ),
                  }),
                  this.playingVideoIndex !== this.playlist.length - 1
                    ? this.playVideo(A, this.playingVideoIndex + 1)
                    : this.playlistTip(
                        this.isEn
                          ? 'Already the last one~'
                          : '已经是最后一个了~',
                        A._el
                      );
              }),
              (this.listHtml.querySelector('.list').onclick = (t) => {
                let e = t.target,
                  i = parseInt(e.getAttribute('data-index'));
                A &&
                  A.trigger('plugin-playlist-click-video', {
                    currentIndex: this.playingVideoIndex,
                    clickedIndex: i,
                  }),
                  'video-item' === e.className && this.playVideo(A, i);
              });
          }
          clearHideListTimeout() {
            null !== this.listHideTimeout &&
              (clearTimeout(this.listHideTimeout),
              (this.listHideTimeout = null));
          }
          playVideo(A, t) {
            this.playingVideoIndex !== t &&
              (A && A.trigger('plugin-playlist-change', { currentIndex: t }),
              (this.playingVideoIndex = parseInt(t)),
              A.loadByUrl(this.playlist[t].source),
              (this.listHtml.querySelector('.video-item.active').className =
                'video-item'),
              (this.listHtml.querySelector('.list').childNodes[t].className =
                'video-item active'));
          }
          tooglePlaylist() {
            this.clearHideListTimeout(),
              '30%' === this.listHtml.style.width
                ? (this.listHtml.style.width = 0)
                : ((this.listHtml.style.width = '30%'),
                  (this.listHideTimeout = setTimeout(() => {
                    this.listHtml.style.width = 0;
                  }, 5e3)));
          }
          playlistTip(A, t) {
            let e = document.createElement('div');
            (e.className = 'playlist-skip-tip'),
              (e.innerText = A),
              t.appendChild(e),
              setTimeout(function () {
                t.removeChild(e);
              }, 3e3);
          }
          computedListDom(A) {
            return A.map(
              (A, t) =>
                `<div class="video-item" data-index="${t}" title="${A.name}">${A.name}</div>`
            ).join('');
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(9918),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.PreviewVodComponent = class {
          constructor(A) {
            let t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : null,
              e =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : null;
            (this.previewDuration = A),
              (this.html = (0, m.a8)(
                '<div class="preview-vod-component"> <div class="preview-component-layer"> <div class="preview-custom"> <p class="preview-default"></p> </div> </div> <div class="preview-component-tip"> <span class="can-preview"></span><span class="preview-time"></span>， <span class="preview-custom-bar">Become VIP Watch Full Version </span> <span class="preview-vod-close">x</span> </div> </div>'
              )),
              null !== t && this.insertHTtml(t, 'previewEndHtml'),
              null !== e && this.insertHTtml(e, 'previewBarHtml');
          }
          play(A) {
            this.previewEnd &&
              (A._el.querySelector('.center').classList.remove('preview-hide'),
              A.seek(0),
              (this.previewEnd = !1));
          }
          insertHTtml(A, t) {
            let e =
                'previewEndHtml' === t
                  ? '.preview-custom'
                  : '.preview-custom-bar',
              i = this.html.querySelector(e);
            if ('string' == typeof A)
              if ('#' === A[0]) {
                let e = document.querySelector(A);
                e
                  ? (i.innerHTML = e.innerHTML)
                  : console.warn(
                      `[aliplayer components warn]: Invalid parameter ${t}, can't find element by this id`
                    );
              } else i.innerHTML = A;
            else
              console.warn(
                `[aliplayer components warn]: Invalid parameter ${t}, ${t} must be a string type`
              );
          }
          ready(A) {
            let t = parseInt(A.getDuration());
            (this.videoDuration = t),
              !this.invalidPreview &&
                this.previewDuration >= t &&
                ((this.invalidPreview = !0),
                console.warn(
                  '[aliplayer components warn]: Invalid parameter previewDuration, previewDuration must be less than the video duration!'
                )),
              0 !== this.previewDuration &&
                this.previewDuration < t &&
                (this.html.style.display = 'block');
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              console.log(this.html.querySelector('.preview-default'));
            let i = this.html.querySelector('.preview-default');
            i && (i.innerText = this.isEn ? 'Preview is over' : '试看已结束'),
              (this.html.querySelector('.can-preview').innerText = this.isEn
                ? 'Try'
                : '可试看');
            let o = this.previewDuration;
            0 === o && (this.html.style.display = 'none');
            let n = o / 60,
              l = n.toString().split('.')[1];
            (n =
              l && l.length > 1
                ? ' ' + o + (this.isEn ? ' senconds' : ' 秒')
                : ' ' + n + (this.isEn ? ' minutes' : ' 分钟')),
              o < 60 && (n = ' ' + o + (this.isEn ? ' senconds' : ' 秒')),
              (this.html.querySelector('.preview-time').innerText = n);
            let s = A.querySelector('video').nextElementSibling;
            s ? A.insertBefore(this.html, s) : A.appendChild(this.html),
              this.html
                .querySelector('.preview-vod-close')
                .addEventListener('click', () => {
                  this.html.querySelector(
                    '.preview-component-tip'
                  ).style.display = 'none';
                }),
              t.setPreviewTime(Number(this.previewDuration));
          }
          closePreviewLayer() {
            (this.previewEnd = !1),
              (this.html.querySelector(
                '.preview-component-layer'
              ).style.display = 'none');
          }
          timeupdate(A) {
            if (
              !this.previewEnd &&
              0 !== this.previewDuration &&
              this.previewDuration < this.videoDuration
            ) {
              let t = A.getPreviewTime(),
                e = A.getCurrentTime();
              Math.floor(t) < e &&
                ((this.previewEnd = !0),
                A._el.querySelector('.center') &&
                  A._el.querySelector('.center').classList.add('preview-hide'),
                A.seek(t),
                A.pause(),
                (this.html.querySelector(
                  '.preview-component-layer'
                ).style.display = 'block'));
            }
          }
          ended(A, t) {
            A.isPreview() &&
              (this.html.querySelector(
                '.preview-component-layer'
              ).style.display = 'block');
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(52),
        t = e(5072),
        i = e.n(t),
        o = e(7825),
        n = e.n(o),
        l = e(7659),
        s = e.n(l),
        a = e(5056),
        r = e.n(a),
        d = e(540),
        c = e.n(d),
        h = e(1113),
        p = e.n(h),
        u = e(2008),
        m = {};
      (m.styleTagTransform = p()),
        (m.setAttributes = r()),
        (m.insert = s().bind(null, 'head')),
        (m.domAPI = n()),
        (m.insertStyleElement = c()),
        i()(u.A, m),
        u.A && u.A.locals && u.A.locals,
        window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.ProgressComponent = class {
          constructor() {
            (this.html = (0, A.a8)(
              '<div class="progress-component"> <div class="progress-content clearfix"> <div class="img-wrap"><img/></div> <div class="info"> <div class="time"></div> <div class="describe"></div> </div> <i href="" target="_blank" class="iconfont icon-play pregress-play-btn"></i> </div> <i class="iconfont icon-arrowdown"></i> </div>'
            )),
              (this.imgEle = this.html.querySelector('.img-wrap img')),
              (this.timeEle = this.html.querySelector('.time')),
              (this.playBtnEle = this.html.querySelector('.pregress-play-btn')),
              (this.describeEle = this.html.querySelector('.describe')),
              (this.timer = null),
              (this.currentOffset = null);
          }
          createEl(A, t) {
            A.appendChild(this.html),
              (this.html.onmouseenter = () => {
                null !== this.timer &&
                  (clearTimeout(this.timer), (this.timer = null));
              }),
              (this.html.onmouseleave = () => {
                this.html.style.display = 'none';
              }),
              (this.html.onclick = () => {
                this.html.style.display = 'none';
              }),
              this.html
                .querySelector('.pregress-play-btn')
                .addEventListener('click', () => {
                  t.seek(this.currentOffset);
                });
          }
          markerDotOver(A, t) {
            let e = A._el.clientWidth,
              i = `calc(${100 * t.left}% - 10px)`;
            e * t.left + 323 > e
              ? ((i = e - 330 + 'px'),
                (this.html.querySelector('.icon-arrowdown').style.left =
                  e * t.left - e + 317 + 'px'))
              : (this.html.querySelector('.icon-arrowdown').style.left =
                  '-2px');
            let {
              coverUrl: o,
              title: n,
              describe: l,
              offset: s,
            } = t.progressMarker;
            (this.currentOffset = s),
              (this.html.style.left = i),
              (this.imgEle.src = o),
              (this.timeEle.innerText = n),
              (this.describeEle.innerText = l),
              (this.html.style.display = 'block');
          }
          markerDotOut(A, t) {
            this.timer = setTimeout(() => {
              this.html.style.display = 'none';
            }, 100);
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(4200),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.QualityComponent = class {
          constructor(A) {
            (this.html = (0, m.a8)(
              '<div class="quality-components"> <div class="current-quality" data-ref=""></div> <ul class="quality-list"> </ul> </div>'
            )),
              (this.modalHtml = (0, m.a8)(
                '<div class="quality-modal"> <span class="switchimg"></span> <span class="current-quality-tag"></span> , <span class="wait"></span> </div>'
              )),
              (this.hasCreated = !1),
              (this.definition = ''),
              (this.getQuality = A);
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector('.current-quality').innerText = this.isEn
                ? 'Resolution'
                : '清晰度'),
              (this.modalHtml.querySelector('.switchimg').innerText = this.isEn
                ? 'Switching to you for'
                : '正在为您切换到'),
              (this.modalHtml.querySelector('.wait').innerText = this.isEn
                ? 'Please wait...'
                : '请稍后...'),
              A.querySelector('.prism-controlbar').appendChild(this.html),
              A.appendChild(this.modalHtml);
          }
          setCurrentQuality(A, t) {
            let e = this.html.querySelector('.current-quality');
            (e.innerText = A), (e.dataset.def = t), (this.definition = t);
            let i = this.html.querySelector('.quality-list'),
              o = i.querySelector('.current');
            o && (o.className = '');
            let n = i.querySelector(`li[data-def="${t}"]`);
            n && (n.className = 'current');
          }
          created(A) {
            this._urls = A._urls;
            let t = this.html.querySelector('.current-quality'),
              e = this.html.querySelector('.quality-list'),
              i = this._urls.map(
                (A) => `<li data-def="${A.definition}">${A.desc}</li>`
              );
            (this.html.querySelector('.quality-list').innerHTML = i.join('')),
              console.log(this.definition),
              0 == this.hasCreated &&
                this.definition &&
                (e.querySelector(
                  `li[data-def="${this.definition}"]`
                ).className = 'current'),
              (this.hasCreated = !0);
            let o = null;
            (t.onclick = () => {
              const A = 'none' !== e.style.display;
              e.style.display = A ? 'none' : 'block';
            }),
              (t.onmouseleave = () => {
                o && clearTimeout(o),
                  (o = setTimeout(() => {
                    e.style.display = 'none';
                  }, 150));
              }),
              (e.onmouseenter = () => {
                clearTimeout(o);
              }),
              (e.onmouseleave = () => {
                o && clearTimeout(o),
                  (o = setTimeout(() => {
                    e.style.display = 'none';
                  }, 150));
              }),
              (e.onclick = (t) => {
                let { target: e } = t,
                  i = e.dataset.def,
                  o = e.innerText;
                if (i && 'current' !== e.className) {
                  let t = Array.isArray(this._urls)
                    ? this._urls.filter((A) => A.definition === i)[0]
                    : this._urls.find((A) => A.definition === i);
                  t &&
                    ((0, m.DR)('selectedStreamLevel', t.definition, 365),
                    A._switchLevel && !A._options.isLive
                      ? A._switchLevel(t.Url)
                      : A._loadByUrlInner(t.Url, A.getCurrentTime(), !0, !0),
                    this.setCurrentQuality(t.desc, t.definition),
                    (this.modalHtml.style.display = 'block'),
                    (this.modalHtml.querySelector(
                      'span.current-quality-tag'
                    ).innerText = t.desc));
                }
                this.getQuality(i, o);
              });
          }
          ready(A) {
            this.modalHtml.style.display = 'none';
            let t = document.querySelector(
              '.prism-setting-item.prism-setting-quality'
            );
            t && t.classList.add('player-hidden');
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(6175),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.RateComponent = class {
          constructor() {
            this.html = (0, m.a8)(
              '<div class="rate-components"> <div class="current-rate">1.0x</div> <ul class="rate-list"> <li data-rate="2.0">2.0x</li> <li data-rate="1.5">1.5x</li> <li data-rate="1.25">1.25x</li> <li data-rate="1.0" class="current">1.0x</li> <li data-rate="0.5">0.5x</li> </ul> </div>'
            );
          }
          createEl(A) {
            A.querySelector('.prism-controlbar').appendChild(this.html);
          }
          ready(A, t) {
            let e = this.html.querySelector('.current-rate'),
              i = this.html.querySelector('.rate-list'),
              o = null,
              n = document.querySelector(
                '.prism-setting-item.prism-setting-speed'
              );
            n && n.classList.add('player-hidden'),
              (e.onclick = () => {
                i.style.display = 'block';
              }),
              (e.onmouseleave = () => {
                o = setTimeout(() => {
                  i.style.display = 'none';
                }, 100);
              }),
              (i.onmouseenter = () => {
                clearTimeout(o);
              }),
              (i.onmouseleave = () => {
                i.style.display = 'none';
              }),
              (i.onclick = (t) => {
                let { target: o } = t,
                  n = o.dataset.rate;
                if (n) {
                  if ((A.setSpeed(n), 'current' !== o.className)) {
                    let A = i.querySelector('.current');
                    A && (A.className = ''), (o.className = 'current');
                  }
                  (i.style.display = 'none'), (e.innerText = n + 'x');
                }
              });
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(6481),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.RotateMirrorComponent = class {
          constructor() {
            this.html = (0, m.a8)(
              '<div class="aliplayer-rotate-mirror"> <i class="iconfont icon-player-rotate-left"></i> <div class="player-tooltip counterclockwise"></div> <i class="iconfont icon-player-rotate-right"></i> <div class="player-tooltip clockwise"></div> <i class="iconfont icon-player-switch"></i> <div class="player-tooltip switch"></div> <div class="mirror-option" style="display:none"> <div class="mirror-item" data-id="vertical"></div> <div class="mirror-item" data-id="horizon"></div> <div class="mirror-item" data-id="counterclockwise"></div> <div class="mirror-item" data-id="clockwise"></div> </div> </div>'
            );
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector(
                '.player-tooltip.counterclockwise'
              ).innerText = this.isEn
                ? 'Rotate 45 degrees counterclockwise'
                : '逆时针旋转45度'),
              (this.html.querySelector(
                '.mirror-item[data-id="counterclockwise"]'
              ).innerText = this.isEn ? 'Rotate left 45 ̊' : '左旋转45˚'),
              (this.html.querySelector(
                '.player-tooltip.clockwise'
              ).innerText = this.isEn
                ? 'Rotate 45 degrees clockwise'
                : '顺时针旋转45度'),
              (this.html.querySelector(
                '.mirror-item[data-id="clockwise"]'
              ).innerText = this.isEn ? 'Rotate right 45 ̊' : '右旋转45˚'),
              (this.html.querySelector(
                '.player-tooltip.switch'
              ).innerText = this.isEn ? 'Mirror' : '镜像'),
              (this.html.querySelector(
                '.mirror-item[data-id=vertical]'
              ).innerText = this.isEn ? 'Vertical mirroring' : '垂直镜像'),
              (this.html.querySelector(
                '.mirror-item[data-id=horizon]'
              ).innerText = this.isEn ? 'Horizontal mirroring' : '水平镜像'),
              A.querySelector('.prism-controlbar').appendChild(this.html);
          }
          ready(A, t) {
            (this.html.querySelector(
              '.icon-player-rotate-left'
            ).onclick = function () {
              let t = A.getRotate();
              A.setRotate(t - 45);
            }),
              (this.html.querySelector(
                '.icon-player-rotate-right'
              ).onclick = function () {
                let t = A.getRotate();
                A.setRotate(t + 45);
              });
            let e = this.html.querySelector('.mirror-option');
            (this.html.querySelector('.icon-player-switch').onclick = () => {
              let A = e.style.display;
              e.style.display = 'none' === A ? 'block' : 'none';
            }),
              (e.onmouseleave = function () {
                this.style.display = 'none';
              }),
              (e.onclick = function (t) {
                let e = t.target;
                if ('counterclockwise' !== e.dataset.id)
                  if ('clockwise' !== e.dataset.id)
                    if (e.className.match('active'))
                      A.cancelImage(), (e.className = 'mirror-item');
                    else {
                      let t =
                        'horizon' === e.dataset.id
                          ? e.previousElementSibling
                          : e.nextElementSibling;
                      t.className.match('active') &&
                        ((t.className = 'mirror-item'), A.cancelImage());
                      let i = e.getAttribute('data-id');
                      A.setImage(i), (e.className = 'mirror-item active');
                    }
                  else {
                    let t = A.getRotate();
                    A.setRotate(t + 45);
                  }
                else {
                  let t = A.getRotate();
                  A.setRotate(t - 45);
                }
              });
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(2484),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.StartADComponent = class {
          constructor(A, t, e) {
            if (
              ((this.coverUrl = A),
              (this.adUrl = t),
              (this.adDuration = e),
              e <= 0)
            )
              throw Error('adDuration must must be greater than 0');
            this.html = (0, m.a8)(
              '<div class="start-ad"> <span class="tip"><span class="ad-name">广告</span>: <i></i><span class="second">秒</span></span> <a class="ad-content" target="_blank"> <img/> </a> </div>'
            );
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector('.ad-name').innerText = this.isEn
                ? 'Ad'
                : '广告'),
              (this.html.querySelector('.second').innerText = this.isEn
                ? 's'
                : '秒');
            let i = this.html.querySelector('.ad-content');
            if (
              (i.setAttribute('href', this.adUrl),
              i.querySelector('img').setAttribute('src', this.coverUrl),
              (this.html.querySelector('.tip i').innerText = this.adDuration),
              A.appendChild(this.html),
              null !== this.html)
            ) {
              'init' !== t.getStatus() && t.pause();
              let A = this.adDuration,
                e = this.html.querySelector('.tip i'),
                i = setInterval(() => {
                  if (((A -= 1), (e.innerText = A), 0 === A)) {
                    clearInterval(i), this.removeComponent();
                    let A = t.getOptions(),
                      e = A.vid || A.source.replace(/\?.*$/, ''),
                      o = localStorage.getItem(e) || 0;
                    o && (o = parseInt(o));
                    let n = t.getOptions() && t.getOptions().components,
                      l = Array.isArray(n)
                        ? n.filter(
                            (A) => 'MemoryPlayComponent' === A.type.name
                          )[0]
                        : n.find((A) => 'MemoryPlayComponent' === A.type.name);
                    (!l || !l.args[0] || t.getCurrentTime() >= o) && t.play();
                  }
                }, 1e3);
            }
          }
          removeComponent() {
            this.html.parentNode.removeChild(this.html), (this.html = null);
          }
          ready(A) {
            null !== this.html && A.pause();
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(9218),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52);
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.TrackComponent = class {
          constructor() {
            (this.trackList = null),
              (this.html = (0, m.a8)(
                '<div class="track-components"> <div class="current-track"></div> <ul class="track-list"> </ul> </div>'
              )),
              (this.modalHtml = (0, m.a8)(
                '<div class="track-modal prism-info-display prism-info-left-bottom"> <span class="switchimg"></span> <span class="current-track-tag"></span> </div>'
              )),
              (this.hasCreated = !1),
              (this.definition = '');
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.modalHtml.querySelector('.switchimg').innerText = this.isEn
                ? 'Track to you for'
                : '音轨切换到'),
              (this.modalHtml.querySelector('.switchimg').style.display =
                'none'),
              A.querySelector('.prism-controlbar').appendChild(this.html),
              A.appendChild(this.modalHtml),
              t.on('audioTrackReady', (A) => {
                let { paramData: t } = A;
                this.trackList = t;
                let e = t.map(
                  (A) => `<li data-def="${A.value}">${A.text}</li>`
                );
                this.html.querySelector('.track-list').innerHTML =
                  '<li style="background:rgba(88,87,86,.5);color:#fff">音轨</li>' +
                  e.join('');
              });
            let i = this.html.querySelector('.current-track'),
              o = this.html.querySelector('.track-list');
            0 == this.hasCreated &&
              this.definition &&
              (o.querySelector(`li[data-def="${this.definition}"]`).className =
                'current'),
              (this.hasCreated = !0);
            let n = null;
            (i.onclick = () => {
              o.style.display = 'block';
            }),
              (i.onmouseleave = () => {
                n = setTimeout(() => {
                  o.style.display = 'none';
                }, 100);
              }),
              (o.onmouseenter = () => {
                clearTimeout(n);
              }),
              (o.onmouseleave = () => {
                (o.style.display = 'none'),
                  (this.modalHtml.style.display = 'none');
              }),
              (o.onclick = (A) => {
                let { target: e } = A,
                  i = e.dataset.def;
                if (i && 'current' !== e.className) {
                  let A = Array.isArray(this.trackList)
                    ? this.trackList.filter((A) => A.value.toString() === i)[0]
                    : this.trackList.find((A) => A.value.toString() === i);
                  t._audioTrackService.switch(A.value),
                    this.setCurrentTrack(A.text, A.value),
                    (this.modalHtml.style.display = 'block'),
                    (this.modalHtml.querySelector('.switchimg').style.display =
                      'block'),
                    (this.modalHtml.querySelector(
                      'span.current-track-tag'
                    ).innerText = A.text);
                }
              });
          }
          setCurrentTrack(A, t) {
            let e = this.html.querySelector('.current-track');
            (e.innerText = A), (e.dataset.def = t), (this.definition = t);
            let i = this.html.querySelector('.track-list'),
              o = i.querySelector('.current');
            o && (o.className = '');
            let n = i.querySelectorAll('li');
            n.forEach((t) => {
              let e = t.innerText;
              e === A && (t.className = 'current'), console.log(e);
            }),
              n && (n.className = 'current');
          }
          created(A) {}
          ready(A) {
            this.modalHtml.style.display = 'none';
            let t = document.querySelector(
              '.prism-setting-item.prism-setting-audio'
            );
            t && t.classList.add('player-hidden');
          }
        });
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(6613),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
      var m = e(52),
        y = e(176);
      let g = class {
        constructor(A, t, e) {
          let i =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : '关闭广告';
          (this.adVideoSource = A),
            (this.adLink = t),
            (this.html = (0, m.a8)(
              '<div class="video-ad-component"> <video id="video-ad-content" x5-video-player-type="h5" x5-video-player-fullscreen="false"></video> <a class="video-ad-link" target="_blank"></a> <div class="video-ad-close"> <span id="video-ad-duration"></span> <label> <span class="video-ad-close-text"></span> <i class="iconfont icon-close"></i> </label> </div> <a class="video-ad-detail" target="_blank"></a> <div class="autoplay-video-ad"> <i class="iconfont icon-player-play"></i> <span class="limit"></span> <span class="manual"></span> </div> <div id="loadflag" class="prism-loading loading-center"> <div class="circle"></div> <div class="circle1"></div> </div> </div>'
            )),
            (this.adInterval = null),
            (this.adCloseFunction = e),
            (this.html.querySelector('.video-ad-close-text').innerText = i),
            (this.adDuration = null),
            (this.player = null);
        }
        createEl(A, t) {
          this.player = t;
          const e = t._options && t._options.language;
          (this.isEn = e && 'en-us' === e),
            (this.html.querySelector('.video-ad-detail').innerText = this.isEn
              ? 'For more information'
              : '查看广告详情'),
            (this.html.querySelector('.limit').innerText = this.isEn
              ? 'Your browser limits autoplay'
              : '您的浏览器限制'),
            (this.html.querySelector('.manual').innerText = this.isEn
              ? 'Please Click'
              : '自动播放请点击');
          let i = this.html.querySelector('#video-ad-content');
          i.setAttribute('src', this.adVideoSource);
          let o = this;
          (this.html.querySelector('.icon-player-play').onclick = () => {
            this.playVideoAd(),
              (this.html.querySelector('.autoplay-video-ad').style.display =
                'none');
          }),
            i.addEventListener('canplay', function A() {
              i.removeEventListener('canplay', A),
                (document.getElementById('loadflag').style.display = 'none'),
                (o.adDuration = Math.ceil(i.duration)),
                (o.html.querySelector('#video-ad-duration').innerText =
                  o.adDuration),
                i
                  .play()
                  .then(() => {
                    o.setAdInterval();
                  })
                  .catch((A) => {
                    o.html.querySelector('.autoplay-video-ad').style.display =
                      'block';
                  });
            });
          let n = this.html.querySelector('.video-ad-link'),
            l = this.html.querySelector('.video-ad-detail');
          n.setAttribute('href', this.adLink),
            l.setAttribute('href', this.adLink),
            A.appendChild(this.html),
            (this.html.querySelector('.video-ad-close label').onclick = () => {
              'function' == typeof this.adCloseFunction
                ? this.adCloseFunction(this)
                : this.closeVideoAd();
            });
        }
        ready(A, t) {
          null !== this.html && (A.pause(), (this.player = A));
        }
        pauseVideoAd() {
          this.clearAdInterval(),
            this.html.querySelector('#video-ad-content').pause();
        }
        playVideoAd() {
          this.setAdInterval(),
            this.html.querySelector('#video-ad-content').play();
        }
        clearAdInterval() {
          null !== this.adInterval && clearInterval(this.adInterval),
            (this.adInterval = null);
        }
        setAdInterval() {
          let A = this.html.querySelector('#video-ad-duration');
          this.adInterval = setInterval(() => {
            (this.adDuration -= 1),
              this.adDuration <= 0
                ? this.closeVideoAd()
                : (A.innerText = this.adDuration);
          }, 1e3);
        }
        closeVideoAd() {
          this.clearAdInterval(),
            this.html.parentNode.removeChild(this.html),
            (this.html = null),
            this.player &&
              this.player.getOptions().autoplay &&
              this.player.play();
        }
      };
      y.A.mobile() &&
        (g = class {
          constructor(A, t, e) {
            let i =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : '关闭广告';
            (this.adVideoSource = A),
              (this.adLink = t),
              (this.html = (0, m.a8)(
                '<div class="video-ad-component" style="background-color:transparent"> <a class="video-ad-link" target="_blank"></a> <div class="video-ad-close"> <span id="video-ad-duration"></span> <label> <span class="video-ad-close-text"></span> <i class="iconfont icon-close"></i> </label> </div> <a class="video-ad-detail" target="_blank"></a> <div class="autoplay-video-ad" style="display:block"> <i class="iconfont icon-player-play"></i> <span class="limit"></span> <span class="manual"></span> </div> </div>'
              )),
              (this.adInterval = null),
              (this.adCloseFunction = e),
              (this.html.querySelector('.video-ad-close-text').innerText = i),
              this.html
                .querySelector('.video-ad-link')
                .setAttribute('href', this.adLink),
              this.html
                .querySelector('.video-ad-detail')
                .setAttribute('href', this.adLink),
              (this.adDuration = null);
          }
          createEl(A, t) {
            const e = t._options && t._options.language;
            (this.isEn = e && 'en-us' === e),
              (this.html.querySelector('.video-ad-detail').innerText = this.isEn
                ? 'For more information'
                : '查看广告详情'),
              (this.html.querySelector('.limit').innerText = this.isEn
                ? 'Your browser limits autoplay'
                : '您的浏览器限制'),
              (this.html.querySelector('.manual').innerText = this.isEn
                ? 'Please Click'
                : '自动播放请点击'),
              A.appendChild(this.html),
              A.querySelector('video'),
              A.querySelector('video').setAttribute('preload', 'load');
            let i = A.querySelector('.prism-controlbar');
            i.className = i.className + ' controlbar-element-hidden';
            let o = A.querySelector('.prism-big-play-btn');
            o.className = o.className + ' controlbar-element-hidden';
          }
          created(A) {
            if (
              ((this.player = A),
              (this.vdSource = A.getOptions().source),
              A.loadByUrl(this.adVideoSource),
              (this.html.querySelector('.autoplay-video-ad').onclick = () => {
                null !== this.adDuration &&
                  (A.loadByUrl(this.adVideoSource),
                  this.html.parentNode
                    .querySelector('.prism-big-play-btn')
                    .click());
              }),
              null === this.adDuration)
            ) {
              this.adDuration = void 0;
              let t = this.html.parentNode.querySelector('video'),
                e = this;
              function i() {
                let o = t.duration;
                isNaN(o) ||
                  0 === o ||
                  (t.removeEventListener('timeupdate', i),
                  (e.adDuration = Math.ceil(t.duration)),
                  'none' !==
                    e.html.querySelector('.autoplay-video-ad').style.display &&
                    ((e.html.querySelector('.autoplay-video-ad').style.display =
                      'none'),
                    A.play()),
                  (e.html.querySelector('#video-ad-duration').innerText =
                    e.adDuration),
                  e.setAdInterval());
              }
              t.addEventListener('timeupdate', i);
            }
          }
          ready(A) {
            this.html.querySelector('.video-ad-close label').onclick = () => {
              'function' == typeof this.adCloseFunction
                ? this.adCloseFunction(this)
                : this.closeVideoAd(),
                document
                  .getElementById(A.id())
                  .getElementsByTagName('video')[0]
                  .play();
            };
          }
          setAdInterval() {
            let A = this.html.querySelector('#video-ad-duration');
            this.adInterval = setInterval(() => {
              (this.adDuration -= 1),
                this.adDuration <= 0
                  ? (this.closeVideoAd(),
                    document
                      .getElementById(this.player.id())
                      .getElementsByTagName('video')[0]
                      .play())
                  : (A.innerText = this.adDuration);
            }, 1e3);
          }
          closeVideoAd() {
            this.clearAdInterval(), this.player.loadByUrl(this.vdSource);
            let A = this.html.parentNode.querySelector('.prism-controlbar');
            A.className = A.className.replace(' controlbar-element-hidden', '');
            let t = this.html.parentNode.querySelector('.prism-big-play-btn');
            (t.className = t.className.replace(
              ' controlbar-element-hidden',
              ''
            )),
              this.player.getOptions().autoplay && this.player.play(),
              this.html.parentNode.removeChild(this.html);
          }
          clearAdInterval() {
            null !== this.adInterval && clearInterval(this.adInterval),
              (this.adInterval = null);
          }
          playVideoAd() {
            this.setAdInterval(), this.player.play();
          }
          pauseVideoAd() {
            this.clearAdInterval(), this.player.pause();
          }
        });
      const M = g;
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.VideoADComponent = M);
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(5570),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals,
        window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.PlayerNextComponent = class {
          constructor(A) {
            (this.clickHandle = A),
              (this._html = document.createElement('div')),
              this._html.setAttribute('class', 'player-olympic-player-next');
            let t = document.createElement('div');
            t.setAttribute('class', 'player-olympic-player-next-tip'),
              (t.textContent = 'Next'),
              this._html.appendChild(t);
          }
          createEl(A) {
            this._html.addEventListener('click', this.clickHandle),
              A.querySelector('.prism-play-btn').insertAdjacentElement(
                'afterend',
                this._html
              );
          }
        });
    })(),
    (() => {
      'use strict';
      const A = e(3915);
      e(5490);
      const t = Aliplayer.Component({
        init: function (t, e) {
          (this.adAddress = t), (this.toAddress = e), (this.$html = $(A));
        },
        createEl: function (A) {
          (Array.isArray(this.$html)
            ? this.$html.filter('.ad')[0]
            : this.$html.find('.ad')
          ).attr('src', this.adAddress);
          var t = Array.isArray(this.$html)
            ? this.$html.filter('.ad-wrapper')[0]
            : this.$html.find('.ad-wrapper');
          t.attr('href', this.toAddress),
            t.click(function () {
              Aliplayer.util.stopPropagation();
            }),
            (Array.isArray(this.$html)
              ? this.$html.filter('.close')[0]
              : this.$html.find('.close')
            ).click(function () {
              this.$html.hide();
            }),
            $(A).append(this.$html);
        },
        ready: function (A, t) {},
        play: function (A, t) {
          this.$html.hide();
        },
        pause: function (A, t) {
          this.$html.show();
        },
        playing: function (A, t) {
          this.$html.hide();
        },
        waiting: function (A, t) {},
        timeupdate: function (A, t) {},
        error: function (A, t) {},
        ended: function (A, t) {
          this.$html.show();
        },
      });
      window.AliPlayerComponent || (window.AliPlayerComponent = {}),
        (window.AliPlayerComponent.StaticAdComponent = t);
    })(),
    (() => {
      'use strict';
      var A = e(5072),
        t = e.n(A),
        i = e(7825),
        o = e.n(i),
        n = e(7659),
        l = e.n(n),
        s = e(5056),
        a = e.n(s),
        r = e(540),
        d = e.n(r),
        c = e(1113),
        h = e.n(c),
        p = e(807),
        u = {};
      (u.styleTagTransform = h()),
        (u.setAttributes = a()),
        (u.insert = l().bind(null, 'head')),
        (u.domAPI = o()),
        (u.insertStyleElement = d()),
        t()(p.A, u),
        p.A && p.A.locals && p.A.locals;
    })();
})();
